import {search_getArrObjFreeIndex} from "./Share_S_Search";
import {crypto_decrypt_fs, crypto_encrypt_fs} from "./Share_S_Crypto";

import {
    validator_array_fb,
    validator_array_typeOf_fb,
    validator_arrayClass_fb,
    validator_boolean_fb,
    validator_class_fb,
    validator_enum_array_fb,
    validator_enum_fb,
    validator_null_fb,
    validator_number_fb,
    validator_obj_fb,
    validator_objClass_fb,
    validator_objKeys_fb,
    validator_objTypeof_fb,
    validator_objValNumber_fb,
    validator_objValStr_fb,
    validator_onjKeysByEnumVal_fb,
    validator_positiveNumber_fb,
    validator_string_fb,
    validator_textByLangCode_fb,
    validator_timestamp_fb,
    validator_typeOf_fb
} from "./Share_S_Validator"

import {
    enum_accessLevelOptions,
    enum_arrangeMissionsType_s,
    enum_audioUrl,
    enum_availableTicketsTypes_s,
    enum_avatar_clothing_e,
    enum_avatar_eyebrow_e,
    enum_avatar_eyes_e,
    enum_avatar_mouth_e,
    enum_avatar_top_accessories_e,
    enum_avatar_top_e,
    enum_avatar_top_facialHair_e,
    enum_cluesMode_e,
    enum_costCurrency_n,
    enum_creatorChargePaymentStatus,
    enum_creatorSendPaymentStatus,
    enum_fbPath,
    enum_featuresMinPoints,
    enum_fileType,
    enum_finishQuest_s,
    enum_hiddenCodesTypes,
    enum_langCodes,
    enum_levelMaxPoints,
    enum_lockQuestionsTypes,
    enum_lockState,
    enum_lockTypes,
    enum_loginMethods,
    enum_mapMissionsTypes,
    enum_mapTypes,
    enum_minMonthlySlotsTicketsPricing,
    enum_missions_LocksType_s,
    enum_moreInfo_featuresIds_s,
    enum_subPlans_s,
    enum_questDiscountCouponHistory_status,
    enum_questEventStartClockTypes_s,
    enum_questLocationsTypes_s,
    enum_questMode_s,
    enum_questPermission_n,
    enum_questTicketActions,
    enum_questTicketStatus,
    enum_questTypes,
    enum_reportReviewStatus_e,
    enum_subCollection_teamStatus,
    enum_subPlan_events,
    enum_subPlan_players,
    enum_subPlan_activeQuests,
    enum_subscriptionTypes,
    enum_typeof, enum_serverStatus, enum_missions_Locks_video_time, enum_typeOfActions, enum_riddleStatusActionTypes,
    enum_paymentRequestBy,
    enum_paymentRequestStatus,
    enum_subPlan_costDollars,
} from "./Share_S_Enum"
import {
    help_random4Digits,
    helper_arrToObj_fo,
    helper_getDisplayLang_e,
    helper_getObjIndexInArray_fn,
    helper_distanceTwoPointsMeters_fn
} from "./Share_S_Helper";
import {format_cost_s, format_costRange_s, format_date_YYYY_MM_fs,} from "./Share_S_Format";
import {obj_forEach_f, obj_map_fo, obj_mapValues_fo, obj_size_fn, obj_toArray_fo} from "./Share_S_Obj";
import {date_nowTime_t} from "./Share_S_Date";
import {gv_colorsDark, gv_numbers} from "./Share_Ass_GlobalVariable";
import {ass_strings} from "./Share_Ass_Dictionary";



// =========== 0) local ==============

// FB_WrapperServerReceived
 class FB_WrapperServerReceived {
    constructor(FBObj) {
        initClass_f(
            'FB_WrapperServerReceived',
            this,
            {
                wsr_serverReceivedData_b :  {
                    oldNames_as: [],
                    val_f: val => val != null ? val : true,
                    validator_f: val => validator_typeOf_fb(val, enum_typeof.boolean)},
            }, FBObj)
    }
}

// =========== 1) BASIC ==============

// FB_Wysiwyg
export class FB_Wysiwyg{

    w_body_s
    w_files_ac

    constructor(FBObj){

        if(!FBObj){FBObj = {}}

        if(validator_typeOf_fb(FBObj, enum_typeof.string) ) {
            this.w_body_s = FBObj
            this.w_files_ac = []
        }

        initClass_f(
            'FB_Wysiwyg',
            this,
            {
                w_body_s : {
                    oldNames_as         : ["body"],
                    val_f(val )          {return val != null ? val : ""},
                    validator_f(val )    {return validator_typeOf_fb(val, enum_typeof.string)}},
                w_files_ac : {
                    oldNames_as         : ["files"],
                    val_f(arr)          {return !arr ? [] : Object.values(arr).map((file) => {return new FB_File(file)})},
                    validator_f(arr)    {return validator_arrayClass_fb(arr, FB_File)}},
            },
            FBObj)
    }

    cm_w_emptyBody_fb(){

        return this.w_body_s === '' || this.w_body_s === '<div></div>'
    }
}

// FB_File
export class FB_File{

    // key in RealTime DB - {fi_uploadDate_t}
    // firestore save as - {fi_m_uniqueFullName_s}

    fi_fileName_s
    fi_type_e

    fi_url_s
    fi_uploadDate_t

    fi_uploadStatus_n
    fi_sizeBytes_n

    fi_index_n
    fi_folderFiles_byUploadDate_c

    static fi_l_folderFiles_byUploadDate_c  = 'fi_folderFiles_byUploadDate_c'

    constructor(FBObj ){

        initClass_f(
            'FB_File',
            this,
            {
                fi_type_e: {
                    oldNames_as     : ['type'],
                    val_f           : (val ) => {return val},
                    validator_f     : (val ) => {return validator_null_fb(val) || validator_enum_fb(enum_fileType, val)}
                },
                fi_fileName_s: {
                    oldNames_as     : ['fileName'],
                    val_f           : (val ) => {return val ? val : ""},
                    validator_f     : (val ) => {return validator_string_fb(val)}
                },

                fi_url_s: {
                    oldNames_as     : ['url'],
                    val_f           : (val ) => {return val},
                    validator_f     : (val ) => {return validator_null_fb(val) || validator_string_fb(val)}
                },
                fi_uploadDate_t: {
                    oldNames_as     : [],
                    val_f           : (val ) => {return val != null ? val : date_nowTime_t()},
                    validator_f     : (val ) => {return validator_timestamp_fb(val)}
                },

                fi_uploadStatus_n: {
                    oldNames_as     : ['uploadStatus'],
                    val_f           : (val ) => {return val ? val : 0},
                    validator_f     : (val ) => {return validator_number_fb(val) && val >= 0 && val <= 1}
                },
                fi_sizeBytes_n: {
                    oldNames_as     : ['f_sizeBytes_n'],
                    val_f           : (val ) => {return val ? val : 0},
                    validator_f     : (val ) => {return validator_number_fb(val)}
                },

                fi_folderFiles_byUploadDate_c: {
                    oldNames_as     : ['fi_folderFiles_byUniqueFullName_c'],
                    val_f           : (val ) => {return val ? obj_map_fo(val, (item) => new FB_File(item)) : {}},
                    validator_f     : (val ) => {return validator_objClass_fb(val, FB_File)}
                },
                fi_index_n: {
                    oldNames_as     : ['index'],
                    val_f           : (val ) => {return val ? val : 0},
                    validator_f     : (val ) => {return validator_number_fb(val)}
                },
            }, FBObj)

    }

    // methods
    fi_m_uniqueFullName_s(){
        return this.fi_uploadDate_t + this.fi_typeSuffix_fs()
    }
    fi_m_nameWithIndex(){
        return this.fi_fileName_s + '_' + this.fi_index_n
    }
    fi_m_fullName_s(){

        return this.fi_fileName_s + this.fi_typeSuffix_fs()
    }
    fi_typeSuffix_fs(){
        switch (this.fi_type_e) {
            case enum_fileType.IMG_svg:
                return'.svg';
            case enum_fileType.IMG:
            case enum_fileType.IMG_png:
            case enum_fileType.IMG_jpeg:
                return '.jpg';
            case enum_fileType.video_mp4:
                return '.mp4';
            case enum_fileType.video_quicktime:
                return '.mov';
            case enum_fileType.audio_mp3:
                return '.mp3';
            case enum_fileType.folder:
                return '';
        }
        return ''
    }
    fi_m_isImage_fb(){
        return this.fi_type_e.includes(enum_fileType.IMG)
    }
    fi_m_isFolder_fb(){
        return this.fi_type_e.includes(enum_fileType.folder)
    }
    fi_m_isVideo_fb(){
        return this.fi_type_e.includes(enum_fileType.VIDEO)
    }
    fi_m_isAudio_fb(){
        return this.fi_type_e.includes(enum_fileType.AUDIO)
    }
    fi_m_isGif_fb(){
        return this.fi_type_e.includes(enum_fileType.IMG_gif)
    }
    fi_m_isSvg_fb(){
        return this.fi_type_e.includes(enum_fileType.IMG_svg)
    }

}

// FB_Report_Review
export class FB_Report_Review{

    constructor(FBObj ){

        initClass_f(
            'FB_Report_Review',
            this,
            {
                rr_reportReview_uid: {
                    oldNames_as     : [],
                    val_f           : (val ) => {return val},
                    validator_f     : (val ) => {return validator_string_fb(val)}
                },
                rr_questId_uid: {
                    oldNames_as     : [],
                    val_f           : (val ) => {return val},
                    validator_f     : (val ) => {return validator_string_fb(val)}
                },
                rr_questType_e: {
                    oldNames_as     : [],
                    val_f           : (val ) => {return val},
                    validator_f     : (val ) => {return validator_enum_fb(enum_questTypes, val)}
                },
                rr_reportUserId_uid: {
                    oldNames_as     : [],
                    val_f           : (val ) => {return val},
                    validator_f     : (val ) => {return validator_string_fb(val)}
                },
                rr_reviewerUserId_uid: {
                    oldNames_as     : [],
                    val_f           : (val ) => {return val},
                    validator_f     : (val ) => {return validator_string_fb(val)}
                },
                rr_reportTime_t: {
                    oldNames_as     : [],
                    val_f           : (val ) => {return val},
                    validator_f     : (val ) => {return validator_timestamp_fb(val)}
                },
                rr_text_s: {
                    oldNames_as     : [],
                    val_f           : (val ) => {return val},
                    validator_f     : (val ) => {return validator_string_fb(val)}
                },
                rr_status_e : {
                    oldNames_as     : [],
                    val_f           : (val ) => {return val},
                    validator_f     : (val ) => {return validator_enum_fb(enum_reportReviewStatus_e, val)}
                },
            }, FBObj)

    }
}

// FB_Cost
export class FB_Cost{

    c_currency_e
    c_value_n

    constructor (FBObj) {

        if(FBObj == null){
            FBObj = {}
        }

        if(FBObj.currency === 'SHEKEL'){
            FBObj.currency = enum_costCurrency_n.SHEKEL;
        }else if(FBObj.currency === 'DOLLAR'){
            FBObj.currency = enum_costCurrency_n.DOLLAR;
        }


        initClass_f(
            'FB_Cost',
            this,
            {
                c_currency_e : {
                    oldNames_as         : ["currency"],
                    val_f(val)          {return val != null ? val : enum_costCurrency_n.SHEKEL},
                    validator_f(val)    {return validator_enum_fb(enum_costCurrency_n, val)}},
                c_value_n : {
                    oldNames_as         : ["value"],
                    val_f(val)          {return val != null ? val : 0},
                    validator_f(val)    {return validator_number_fb(val)}},
            },
            FBObj)

    }

    c_m_changeCurrency_c (newCurrency_e ) {

        let dollarToShekelRate_n = 3.16
        let euroToShekelRate_n = 3.96
        let euroToDollar = 1.19
        let value_n = 0


        if(this.c_currency_e === newCurrency_e){
            return new FB_Cost({
                c_currency_e : newCurrency_e,
                c_value_n : this.c_value_n
            })
        }

        switch(this.c_currency_e){
            case enum_costCurrency_n.DOLLAR:
                switch(newCurrency_e){
                    case enum_costCurrency_n.DOLLAR:
                        break;
                    case enum_costCurrency_n.SHEKEL:
                        value_n = Math.ceil(this.c_value_n * dollarToShekelRate_n)
                        break;
                    case enum_costCurrency_n.EURO:
                        value_n = Math.ceil(this.c_value_n / euroToDollar)
                        break;
                }
                break;
            case enum_costCurrency_n.SHEKEL:
                switch(newCurrency_e){
                    case enum_costCurrency_n.DOLLAR:
                        value_n = Math.ceil(this.c_value_n / dollarToShekelRate_n)
                        break;
                    case enum_costCurrency_n.SHEKEL:
                        break;
                    case enum_costCurrency_n.EURO:
                        value_n = Math.ceil(this.c_value_n / euroToShekelRate_n)

                        break;
                }
                break;
            case enum_costCurrency_n.EURO:
                switch(newCurrency_e){
                    case enum_costCurrency_n.DOLLAR:
                        value_n = Math.ceil(this.c_value_n * euroToDollar)
                        break;
                    case enum_costCurrency_n.SHEKEL:
                        value_n = Math.ceil(this.c_value_n * euroToShekelRate_n)
                        break;
                    case enum_costCurrency_n.EURO:
                        break;
                }
                break;
        }


        return new FB_Cost({
            c_currency_e : newCurrency_e,
            c_value_n : value_n
        })
    }

    c_m_toString(){
        return format_cost_s(this)
    }

}

// FB_FunctionAns
export class FB_ServerAns {
    sa_status_e
    sa_msg_s

    constructor (FBObj) {


        initClass_f(
            'FB_FunctionAns',
            this,
            {
                sa_status_e : {
                    val_f(val)          {return val},
                    validator_f(val)    {return validator_enum_fb(enum_serverStatus, val)}},
                sa_msg_s : {
                    val_f(val)          {return val ? val : ""},
                    validator_f(val)    {return validator_string_fb(val)}},
            },
            FBObj)

    }
}

// FB_WhiteLabel
export class FB_WhiteLabel {
    constructor (FBObj) {
        initClass_f('FB_WhiteLabel', this, {
            wl_title_s: {
                val_f : val => val,
                validator_f : val => validator_null_fb(val) ||  validator_string_fb(val)},
            wl_logoUrl_s: {
                val_f : val => val,
                validator_f : val => validator_null_fb(val) ||  validator_string_fb(val)},
            wl_color_s: {
                val_f : val => val,
                validator_f : val => validator_null_fb(val) ||  validator_string_fb(val)},
            wl_backgroundColor_s: {
                val_f : val => val,
                validator_f : val => validator_null_fb(val) ||  validator_string_fb(val)},
        }, FBObj)
    }
}

// =========== 2) Realtime DB ==============

// FB_UserData
export class FB_UserData {

    ud_accessLevel_n ;
    ud_name_s       ;
    ud_email_s       ;
    ud_avatar_c       ;
    ud_userId_uid       ;
    ud_levelTotalPoints_n       ;
    ud_loginMethods_ae       ;

    static ud_label_email_s = 'ud_email_s'
    static ud_l_loginMethods_ae = 'ud_loginMethods_ae'

    constructor (FBObj  ) {

        if(FBObj.ud_avatar_c == null  && FBObj.ud_imgFile_c != null){
            FBObj.ud_avatar_c = new FB_UserData_Avatar({
                cuda_avatarImage_b: true,
                cuda_imgFile_c: FBObj.ud_imgFile_c
            })
        }

        if(FBObj.ud_avatar_c == null  && FBObj.ud_imageFile_c != null){
            FBObj.ud_avatar_c = new FB_UserData_Avatar({
                cuda_avatarImage_b: true,
                cuda_imgFile_c: FBObj.ud_imageFile_c
            })
        }

        initClass_f(
            'FB_UserData - ' + FBObj.ud_userId_uid,
            this, {
                ud_userId_uid       : {
                    val_f(val) {return val},
                    validator_f(val) {return validator_string_fb(val)}},
                ud_avatar_c         : {
                    oldNames_as : [],
                    val_f(val) {return val ? new FB_UserData_Avatar(val) : new FB_UserData_Avatar({})},
                    validator_f(val) {return validator_class_fb(val, FB_UserData_Avatar)}},
                ud_name_s           : {
                    val_f(val) {return val != null ? val : "NewUser" + help_random4Digits()},
                    validator_f(val) {return validator_string_fb(val)}},
                ud_email_s          : {
                    val_f(val) {return val},
                    validator_f(val) {return validator_null_fb(val) || validator_string_fb(val)}},
                ud_phone_s          : {
                    val_f(val) {return val},
                    validator_f(val) {return validator_null_fb(val) || validator_string_fb(val)}},
                ud_idNumber_s       : {
                    val_f(val) {return val},
                    validator_f(val) {return validator_null_fb(val) || validator_string_fb(val)}},
                ud_accessLevel_n    : {
                    val_f(val) {return val ? val : enum_accessLevelOptions.player},
                    validator_f(val) {return validator_enum_fb(enum_accessLevelOptions, val)}},
                ud_creationTime_t   : {
                    val_f(val) {return val},
                    validator_f(val) {return val == null || validator_number_fb(val)}},
                ud_langCode_e       : {
                    val_f(val) {return val != null ? val : enum_langCodes.hebrew},
                    validator_f(val) {return validator_enum_fb(enum_langCodes, val)}},
                ud_tqProfitPercentage_n : {
                    attExists_b : ()    => {return this.ud_accessLevel_n >= enum_accessLevelOptions.creator},
                    val_f       : (val) => {return val != null ? val : 20},
                    validator_f : (val) => {return validator_typeOf_fb(val, enum_typeof.number)}},
                ud_loginMethods_ae: {
                    val_f(val)          {return val ? Object.values(val) : []},
                    validator_f(val)    {return validator_enum_array_fb(enum_loginMethods, val)}},
                ud_levelTotalPoints_n: {
                    val_f(val)          {return val ? val : 10},
                    validator_f(val)    {return validator_number_fb(val)}},
                ud_approveCooliesPolicyVersion_s: {
                    val_f(val)          {return val ? val : "000"},
                    validator_f(val)    {return validator_string_fb(val)}},
                ud_approveTermsOfUseVersion_s: {
                    val_f(val)          {return val ? val : "000"},
                    validator_f(val)    {return validator_string_fb(val)}},
            }, FBObj)
    }

    ud_m_guestUser_b(){
        return this.ud_loginMethods_ae.length === 1 && this.ud_loginMethods_ae[0] === enum_loginMethods.guest
    }
    ud_m_level_s(){

        let levelMaxPoints_as = Object.values(enum_levelMaxPoints)

        for(let index_n=levelMaxPoints_as.length-1; index_n>=0; index_n--){
            let maxPoints_n = levelMaxPoints_as[index_n]

            if(this.ud_levelTotalPoints_n >= maxPoints_n){
                return index_n + 1
            }
        }
        return 1
    }

    ud_m_getUrlFromEmail_fs(){
        let emailSplit_as  = this.ud_email_s.toLowerCase().split("@")

        switch(emailSplit_as[1]){

            case 'gmail.com':
                return emailSplit_as[0]
            default:
                return this.ud_email_s
        }
    }

    static ud_m_s_getEmailFromUrl_fs(emailFromUrl_s){
        let emailSplit_as  =  emailFromUrl_s.toLowerCase().split("@")

        if(emailSplit_as.length > 1){
            return emailFromUrl_s
        }else{
            return emailFromUrl_s + '@gmail.com'
        }

    }
}
export class FB_UserData_Avatar {

    cuda_top_e
    cuda_clothing_e
    cuda_eyes_e
    cuda_mouth_e
    cuda_eyebrow_e
    cuda_facialHair_e
    cuda_accessories_e
    cuda_clothingColor_s
    cuda_hairColor_s
    cuda_avatarImage_b
    cuda_imgFile_c

    constructor (FBObj) {

        initClass_f(
            'FB_UserData_Avatar',
            this, {
                cuda_avatarImage_b :{
                    oldNames_as : [],
                    val_f(val) {return val ? val : false},
                    validator_f(val) {return validator_boolean_fb(val)}},
                cuda_imgFile_c : {
                    oldNames_as : [],
                    val_f(val) {return val ? new FB_File(val) : new FB_File({})},
                    validator_f(val) {return validator_class_fb(val, FB_File)}},
                cuda_top_e : {
                    val_f(val)          {return val ? val : enum_avatar_top_e.ShaggyMullet},
                    validator_f(val)    {return validator_enum_fb(enum_avatar_top_e, val)}},
                cuda_hairColor_s : {
                    val_f(val)          {return val ? val : Object.values(gv_colorsDark)[Math.floor(Math.random()*obj_size_fn(gv_colorsDark))] },
                    validator_f(val)    {return validator_string_fb(val)}},
                cuda_clothing_e : {
                    val_f(val)          {return val ? val : Object.values(enum_avatar_clothing_e)[Math.floor(Math.random()*obj_size_fn(enum_avatar_clothing_e))]},
                    validator_f(val)    {return validator_enum_fb(enum_avatar_clothing_e, val)}},
                cuda_eyes_e : {
                    val_f(val)          {return val ? val : enum_avatar_eyes_e.Default},
                    validator_f(val)    {return validator_enum_fb(enum_avatar_eyes_e, val)}},
                cuda_mouth_e : {
                    val_f(val)          {return val ? val : enum_avatar_mouth_e.Smile },
                    validator_f(val)    {return validator_enum_fb(enum_avatar_mouth_e, val)}},
                cuda_eyebrow_e : {
                    val_f(val)          {return val ? val : enum_avatar_eyebrow_e.Default },
                    validator_f(val)    {return validator_enum_fb(enum_avatar_eyebrow_e, val)}},
                cuda_facialHair_e : {
                    val_f(val)          {return val ? val : enum_avatar_top_facialHair_e.blank },
                    validator_f(val)    {return validator_enum_fb(enum_avatar_top_facialHair_e, val)}},
                cuda_accessories_e : {
                    val_f(val)          {return val ? val : enum_avatar_top_accessories_e.blank },
                    validator_f(val)    {return validator_enum_fb(enum_avatar_top_accessories_e, val)}},
                cuda_clothingColor_s : {
                    val_f(val)          {return val ? val : Object.values(gv_colorsDark)[Math.floor(Math.random()*obj_size_fn(gv_colorsDark))] },
                    validator_f(val)    {return validator_string_fb(val)}},
            }, FBObj)
    }

    uda_m_random_f(){
        this.cuda_top_e = Object.values(enum_avatar_top_e)[Math.floor(Math.random()*obj_size_fn(enum_avatar_top_e))]
        this.cuda_hairColor_s = Object.values(gv_colorsDark)[Math.floor(Math.random()*obj_size_fn(gv_colorsDark))]
        this.cuda_clothing_e = Object.values(enum_avatar_clothing_e)[Math.floor(Math.random()*obj_size_fn(enum_avatar_clothing_e))]
        this.cuda_clothingColor_s = Object.values(gv_colorsDark)[Math.floor(Math.random()*obj_size_fn(gv_colorsDark))]
        this.cuda_eyes_e = Object.values(enum_avatar_eyes_e)[Math.floor(Math.random()*obj_size_fn(enum_avatar_eyes_e))]
        this.cuda_mouth_e = Object.values(enum_avatar_mouth_e)[Math.floor(Math.random()*obj_size_fn(enum_avatar_mouth_e))]
        this.cuda_eyebrow_e = Object.values(enum_avatar_eyebrow_e)[Math.floor(Math.random()*obj_size_fn(enum_avatar_eyebrow_e))]
        this.cuda_facialHair_e = Object.values(enum_avatar_top_facialHair_e)[Math.floor(Math.random()*obj_size_fn(enum_avatar_top_facialHair_e))]
        this.cuda_accessories_e = Object.values(enum_avatar_top_accessories_e)[Math.floor(Math.random()*obj_size_fn(enum_avatar_top_accessories_e))]
    }
}

// FB_UserDataSub
export class FB_UserDataSub_MoreInfo {

    udsmi_langArr_ae ;
    udsmi_mainLang_e ;
    udsmi_about_blc_s ;

    constructor (FBObj ) {

        if(FBObj.udsmi_about_blc_s == null && FBObj.udsmi_about_s != null){
            FBObj.udsmi_about_blc_s = {iw : FBObj.udsmi_about_s}
        }

        initClass_f(
            'FB_UserDataSub_moreInfo - ' + FBObj.udsmi_userId_uid,
            this, {
                udsmi_userId_uid : {
                    val_f(val)          {return val},
                    validator_f(val)    {return validator_string_fb(val)}},
                udsmi_about_s : {
                    val_f(val)          {return val ? val : ""},
                    validator_f(val)    {return validator_string_fb(val)}},
                udsmi_about_blc_s : {
                    val_f(val)          {return val ? val : {}},
                    validator_f(val)    {return validator_obj_fb(val)}},
                udsmi_mainLang_e : {
                    val_f(val)          {return val ? val : enum_langCodes.hebrew},
                    validator_f(val)    {return validator_enum_fb(enum_langCodes, val)}},
                udsmi_langArr_ae : {
                    val_f(arr)          {return arr ? arr : [enum_langCodes.hebrew]},
                    validator_f(arr )    {return validator_enum_array_fb(enum_langCodes, arr)}},
                udsmi_phone_s : {
                    val_f(val)          {return val ? val : ""},
                    validator_f(val)    {return validator_string_fb(val)}},
                udsmi_tqDriveSize_n : {
                    val_f(val)          {return val!= null ? val : gv_numbers.maxFileSizeInByte},
                    validator_f(val)    {return validator_number_fb(val)}},
            }, FBObj)
    }

    udsmi_cm_about_fs(systemLangCode_e ){
        let langCode_e = helper_getDisplayLang_e(systemLangCode_e, this.udsmi_langArr_ae, this.udsmi_mainLang_e)
        return this.udsmi_about_blc_s[langCode_e] ? this.udsmi_about_blc_s[langCode_e] : ''
    }

}
export class FB_UserDataSub_OnlineUser {

    ud_os_online_b 
    ud_os_userId_uid 

    static ud_os_l_online_b = "ud_os_online_b"

    constructor (FBObj ) {

        initClass_f(
            'FB_UserDataSub_OnlineUsers - ' + FBObj.os_userId_uid,
            this, {
                ud_os_userId_uid : {
                    val_f(val)          {return val},
                    validator_f(val)    {return validator_string_fb(val)}},
                ud_os_online_b: {
                    val_f(val)          {return val ? val : false},
                    validator_f(val)    {return validator_boolean_fb(val)}},
            }, FBObj)
    }

}
export class FB_UserDataSub_CreatorPaymentInfo {

    constructor (FBObj ) {
        initClass_f(
            'FB_UserDataSub_PrivateData - ' + FBObj.udscpi_userId_uid,
            this, {
                udscpi_userId_uid: {
                    val_f(val)          {return val},
                    validator_f(val)    {return validator_string_fb(val)}},
                udscpi_bank_n : {
                    val_f(val)          {return val},
                    validator_f(val)    {return validator_null_fb(val) || validator_number_fb(val)}},
                udscpi_accountNum_s : {
                    val_f(val)          {return val },
                    validator_f(val)    {return validator_null_fb(val) || validator_string_fb(val)}},
                udscpi_branchNum_s : {
                    val_f(val)          {return val},
                    validator_f(val)    {return validator_null_fb(val) || validator_string_fb(val)}},
                udscpi_subPlanCost_c : {
                    val_f(val)          {return val ? new FB_Cost(val) : new FB_Cost({})},
                    validator_f(val)    {return validator_class_fb(val, FB_Cost)}},
            }, FBObj)
    }


}
export class FB_UserDataSub_SubscriptionPlanInfo {

    udsspi_endSubscription_t

    udsspi_maxQuests_n
    udsspi_maxEvents_n
    udsspi_maxPlayers_n
    udsspi_userId_uid
    udsspi_initCost_c
    udsspi_subscriptionPaymentType_e
    udsspi_renewCost_c
    udsspi_renewSubscription_c

    constructor (FBObj ) {
        initClass_f(
            'FB_UserDataSub_SubscriptionPlanInfo - ' + FBObj.udsspi_userId_uid,
            this, {
                udsspi_userId_uid: {
                    val_f(val)          {return val},
                    validator_f(val)    {return validator_string_fb(val)}},
                udsspi_autoRenew_b: {
                    val_f(val)          {return val ? val : true},
                    validator_f(val)    {return validator_boolean_fb(val)}},
                udsspi_subscriptionPaymentType_e : {
                    val_f(val)          {return val ? val : enum_subscriptionTypes.monthly},
                    validator_f(val)    {return validator_enum_fb(enum_subscriptionTypes, val)}},
                udsspi_endSubscription_t: {
                    val_f(val)          {return val},
                    validator_f(val)    {return validator_null_fb(val) || validator_timestamp_fb(val)}},

                udsspi_maxQuests_n: {
                    val_f(val)          {return val ? val : enum_subPlan_activeQuests.free},
                    validator_f(val)    {return validator_number_fb(val)}},
                udsspi_maxEvents_n: {
                    val_f(val)          {return val ? val : enum_subPlan_events.free},
                    validator_f(val)    {return validator_number_fb(val)}},
                udsspi_maxPlayers_n: {
                    val_f(val)          {return val ? val : enum_subPlan_players.free},
                    validator_f(val)    {return validator_number_fb(val)}},
                udsspi_initCost_c: {
                    val_f(val)          {return new FB_Cost(val)},
                    validator_f(val)    {return validator_class_fb(val, FB_Cost)}},
                udsspi_renewCost_c: {
                    val_f(val)          {return new FB_Cost(val)},
                    validator_f(val)    {return validator_class_fb(val, FB_Cost)}},
                udsspi_renewSubscription_c: {
                    val_f(val)          {return val ? new FB_UserDataSub_SubscriptionPlanInfo(val) : null},
                    validator_f(val)    {return validator_null_fb(val) || validator_class_fb(val, FB_UserDataSub_SubscriptionPlanInfo)}},
            }, FBObj)
    }

    udsspi_m_subscriptionPlan_e(){
        switch(this.udsspi_maxQuests_n){
            case enum_subPlan_activeQuests.free:
                return enum_subPlans_s.free
            case enum_subPlan_activeQuests.basic:
                return enum_subPlans_s.basic
            case enum_subPlan_activeQuests.advanced:
                return enum_subPlans_s.advanced
            case enum_subPlan_activeQuests.pro:
                return enum_subPlans_s.pro
            default:
                return enum_subPlans_s.legend
        }
    }

    udsspi_m_activePaymentPlan_b(){

        // trail = not active
        if(this.udsspi_m_subscriptionPlan_e() === enum_subPlans_s.free){
            return false
        }

        // no date inactive
        if(!this.udsspi_endSubscription_t){
            return false
        }

        let now_d = new Date()
        now_d.getFullYear();
        now_d.getMonth();

        let subDate_d = new Date(this.udsspi_endSubscription_t)

        let pastYear_b = now_d.getFullYear() < subDate_d.getFullYear()
        let pastMonth_b = now_d.getFullYear() === subDate_d.getFullYear() && now_d.getMonth() < subDate_d.getMonth()

        return pastYear_b || pastMonth_b

    }

    udsspi_m_getPlanLevel_n(){
        switch(this.udsspi_m_subscriptionPlan_e()){
            case enum_subPlans_s.free:
                return 1
            case enum_subPlans_s.basic:
                return 2
            case enum_subPlans_s.advence:
                return 3
            case enum_subPlans_s.pro:
                return 4
            case enum_subPlans_s.legend:
                return 5
        }
    }



}
export class FB_UserDataSub_chargePaymentHistory {

    udscph_userId_uid
    udscph_createdDate_t
    udscph_cost_c
    udscph_tqReceipt_s
    udscph_maxPlayers_n
    udscph_subscriptionType_e

    constructor (FBObj ) {
        initClass_f(
            'FB_UserDataSub_chargePaymentHistory - ' + FBObj.udscph_userId_uid,
            this, {
                udscph_userId_uid: {
                    val_f(val)          {return val},
                    validator_f(val)    {return validator_string_fb(val)}},
                udscph_createdDate_t: {
                    val_f(val)          {return val ? val : false},
                    validator_f(val)    {return validator_timestamp_fb(val)}},
                udscph_cost_c : {
                    val_f(val)          {return val ? val : enum_subscriptionTypes.monthly},
                    validator_f(val)    {return validator_class_fb(val, FB_Cost)}},
                udscph_tqReceipt_s: {
                    val_f(val)          {return val},
                    validator_f(val)    {return validator_string_fb(val)}},
                udscph_maxPlayers_n: {
                    val_f(val)          {return val},
                    validator_f(val)    {return validator_number_fb(val)}},
                udscph_subscriptionType_e: {
                    val_f(val)          {return val},
                    validator_f(val)    {return validator_enum_fb(enum_subscriptionTypes, val)}},
                udscph_status_e: {
                    val_f(val)          {return val},
                    validator_f(val)    {return validator_enum_fb(enum_creatorChargePaymentStatus, val)}},

            }, FBObj)
    }



}
export class FB_UserDataSub_QuestPermission {

    udsqp_questId_uid;
    udsqp_questType_e;
    udsqp_userId_uid;
    udsqp_permission_n;

    constructor (FBObj ) {

        initClass_f(
            'FB_UserDataSub_QuestPermission - ' + FBObj.udsqp_id_uid,
            this, {
                udsqp_questId_uid: {
                    val_f(val)          {return val},
                    validator_f(val)    {return validator_string_fb(val)}},
                udsqp_userId_uid: {
                    val_f(val)          {return val},
                    validator_f(val)    {return validator_string_fb(val)}},
                udsqp_permission_n: {
                    val_f(val)          {return val},
                    validator_f(val)    {return validator_enum_fb(enum_questPermission_n, val)}},
                udsqp_questType_e: {
                    val_f(val)          {return val },
                    validator_f(val)    {return validator_enum_fb(enum_questTypes, val)}},
            }, FBObj)
    }

    udsqp_m_id_fs(){
        return `${this.udsqp_questId_uid}_${this.udsqp_questType_e}_${this.udsqp_userId_uid}`
    }
}
export class FB_UserDataSub_CreditCard {

    udscc_cardNum_s 
    udscc_cardDueDateMMYY_s
    udscc_status_n

    constructor (FBObj ) {

        initClass_f(
            'FB_UserDataSub_CreditCard - ' + FBObj.udscc_userId_uid,
            this, {
                udscc_userId_uid: {
                    val_f(val)          {return val},
                    validator_f(val)    {return validator_string_fb(val)}},
                udscc_paymentToken_s: {
                    val_f(val)          {return val},
                    validator_f(val)    {return validator_string_fb(val)}},
                udscc_saleId_uid: {
                    val_f(val)          {return val},
                    validator_f(val)    {return validator_string_fb(val)}},
                udscc_cardName_s: {
                    val_f(val)          {return val},
                    validator_f(val)    {return validator_string_fb(val)}},
                udscc_cardNum_s: {
                    val_f(val)          {return val},
                    validator_f(val)    {return validator_string_fb(val)}},
                udscc_cardDueDateMMYY_s: {
                    val_f(val)          {return val},
                    validator_f(val)    {return validator_string_fb(val)}},
                udscc_timestamp_t: {
                    val_f(val)          {return val},
                    validator_f(val)    {return validator_timestamp_fb(val)}},
                udscc_mainCardDate_t: {
                    val_f(val)          {return val ? val : null},
                    validator_f(val)    {return validator_null_fb(val) || validator_timestamp_fb(val)}},
                udscc_status_n: {
                    val_f(val)          {return val ? val : 0},
                    validator_f(val)    {return validator_number_fb(val)}},
            }, FBObj)
    }

    udscc_m_id_s(){
        return this.udscc_cardDueDateMMYY_s + this.udscc_cardNum_s
    }
    udscc_m_cardDueDateFormat_s(){
        return `${this.udscc_cardDueDateMMYY_s.substring(0,2)}/${this.udscc_cardDueDateMMYY_s.substring(2,4)}`
    }


    static udscc_ms_getCardNumOnlyLast4Dig_s(cardNumWithPrefix_s){
        let suffix = cardNumWithPrefix_s.slice(-4)
        let length = cardNumWithPrefix_s.length

        let prefix = ""
        while(length > 4){
            prefix += "X"
            length--
        }
        return prefix + suffix
    }

    static udscc_ms_getMainCreditCard_c(uds_creditCards_byId_c){

        let mainCreditCard_c = null

        for(let creditCardId_s in uds_creditCards_byId_c){
            let currentCreditCard_c = uds_creditCards_byId_c[creditCardId_s]

            if(currentCreditCard_c.udscc_status_n != 0){
                continue
            }

            if(currentCreditCard_c.udscc_mainCard_b){
                return currentCreditCard_c
            }

            if(mainCreditCard_c == null ||
                mainCreditCard_c.udscc_mainCardDate_t < currentCreditCard_c.udscc_mainCardDate_t ||
                (mainCreditCard_c.udscc_mainCardDate_t == null && mainCreditCard_c.udscc_timestamp_t > currentCreditCard_c.udscc_timestamp_t)){
                mainCreditCard_c = currentCreditCard_c
            }


        }

        return mainCreditCard_c


    }

}
export class FB_UDS_CreatorMonthlyTickets {

    udscmt_userId_uid
    udscmt_yyyy_mm_s
    udscmt_totalSpots_n
    udscmt_receipt_s

    constructor (FBObj ) {

        initClass_f(
            'FB_UserDataSub_CreatorMonthlyTickets - ' + FBObj.udscmt_userId_uid,
            this, {
                udscmt_userId_uid: {
                    val_f(val)          {return val},
                    validator_f(val)    {return validator_string_fb(val)}},
                udscmt_yyyy_mm_s: {
                    val_f(val)          {return val},
                    validator_f(val)    {return validator_string_fb(val)}},
                udscmt_totalSpots_n: {
                    val_f(val)          {return val},
                    validator_f(val)    {return validator_number_fb(val)}},
                udscmt_receipt_s: {
                    val_f(val)          {return val},
                    validator_f(val)    {return validator_null_fb(val) || validator_string_fb(val)}},
            }, FBObj)
    }

    static udscmt_ms_monthKey_yyyy_mm_fs(date_s){
        return format_date_YYYY_MM_fs(date_s, null)
    }

    udscmt_m_month_yyyy_mm_fs(){
        return format_date_YYYY_MM_fs(this.udscmt_yyyy_mm_s, null)
    }


}
export class FB_UDS_QuestTicketPointer {
    constructor (FBObj) {

        initClass_f('FB_QuestTicketPointer' + FBObj.qetp_ticketId_uid, this, {
            qetp_ticketId_uid : {
                oldNames_as :       ['tp_ticketId_uid', "qtp_ticketId_uid"],
                val_f(val)          {return val},
                validator_f(val)    {return validator_string_fb(val)}},
            qetp_eventStartingDate_t : {
                oldNames_as :       [],
                val_f(val)          {return val ? val : (new Date()).getTime()},
                validator_f(val)    {return validator_typeOf_fb(val, enum_typeof.number)}},
            qetp_orderBy_uid : { // qetp_eventStartingDate_t + qetp_eventStartingDate_t
                oldNames_as :       [],
                val_f(val)          {return val ? val : ""},
                validator_f(val)    {return validator_string_fb(val)}},
        }, FBObj)
    }
}

// FB_TicketShortKey
export class FB_TicketShortKey{

    tsk_shortKeyId_s 

    constructor(FBObj ){

        initClass_f(
            'FB_File',
            this,
            {
                tsk_shortKeyId_s: {
                    oldNames_as     : [],
                    val_f           : (val ) => {return val},
                    validator_f     : (val ) => {return validator_string_fb(val)}
                },
                tsk_createDate_t: {
                    oldNames_as     : [],
                    val_f           : (val ) => {return val},
                    validator_f     : (val ) => {return validator_timestamp_fb(val)}
                },
                tsk_ticketId_uid: {
                    oldNames_as     : [],
                    val_f           : (val ) => {return val},
                    validator_f     : (val ) => {return validator_string_fb(val)}
                },
                tsk_lifespanInDays_n : {
                    oldNames_as     : [],
                    val_f           : (val ) => {return val},
                    validator_f     : (val ) => {return validator_number_fb(val)}
                },


            }, FBObj)

    }
    cm_tsk_getShortId_prefix_fs(){
        return this.tsk_shortKeyId_s.substring(0,2)
    }
    cm_tsk_getShortId_suffix_fs(){
        return this.tsk_shortKeyId_s.substring(2)
    }

}

// FB_QuestTicket
export class FB_QuestTicket {

    qt_discountPercentage_n
    qt_questType_e
    qt_questId_uid
    qt_playerId_uid
    qt_couponId_uid
    qt_history_ac
    qt_cost_c
    qt_saleDate_t
    qt_ticketId_uid
    qt_agentId_uid
    qt_creatorText_s
    qt_status_e
    qt_spots_n
    qt_playersJoinDate_byUserId_t

    constructor(FBObj ) {

        initClass_f('FB_QuestTicket' + FBObj.qt_ticketId_uid, this, {

            qt_ticketId_uid : {
                oldNames_as :       ["ticketId"],
                val_f(val )          {return val},
                validator_f(val )    {return  validator_null_fb(val) || validator_string_fb(val)}},
            qt_shortKeyId_s : {
                oldNames_as :       [],
                val_f(val )          {return val ? val : "000000"},
                validator_f(val )    {return  validator_string_fb(val)}},
            qt_questType_e : {
                oldNames_as :       ["questType"],
                val_f(val) {return val},
                validator_f(val) {return validator_enum_fb(enum_questTypes, val)}},
            qt_questId_uid  : {
                oldNames_as :       ["questId"],
                val_f(val) {return val},
                validator_f(val) {return validator_string_fb(val)}},
            qt_eventId_uid : {
                oldNames_as :       ["eventId"],
                val_f(val) {return val},
                validator_f(val) {return true || validator_string_fb(val)}},
            qt_playerId_uid : {
                oldNames_as :       ["boughtByUserId"],
                val_f(val) {return val},
                validator_f(val) {return validator_string_fb(val)}},
            qt_creatorId_uid : {
                oldNames_as :       [],
                val_f(val) {return val},
                validator_f(val) {return validator_string_fb(val) || validator_null_fb(val)}},
            qt_eventStartingDate_t: {
                oldNames_as :       [],
                val_f(val )       {return val ? val : (new Date()).getTime()},
                validator_f(val ) {return validator_number_fb(val)}},

            qt_playersJoinDate_byUserId_t : {
                oldNames_as :       ["playersIds"],
                val_f(val) {return val ? val : {}},
                validator_f(val) {return true}},
            qt_saleDate_t : {
                oldNames_as :       [],
                val_f(val) {return val},
                validator_f(val) {return validator_number_fb(val)}},
            qt_purchasedBy_e : {
                oldNames_as         : [],
                val_f(val_e)          {return val_e ? val_e : FBObj.qt_boughtByCreator_b ? enum_accessLevelOptions.creator : enum_accessLevelOptions.player},
                validator_f(val_e)    {return validator_enum_fb(enum_accessLevelOptions, val_e)}},

            qt_receiptLink_s:{
                oldNames_as :       [],
                val_f(val)       {return val},
                validator_f(val) {return validator_null_fb(val) || validator_typeOf_fb(val, enum_typeof.string)},},
            qt_status_e : {
                oldNames_as :       [],
                val_f(val) {return val},
                validator_f(val) {return validator_enum_fb(enum_questTicketStatus, val)}},
            qt_history_ac : {
                oldNames_as :       [],
                val_f(val) {return val ? Object.values(val).map((item )=> {return new FB_QuestTicket_History(item)}) : []},
                validator_f(val) {return true}},

            qt_spots_n : {
                oldNames_as :       ["spots"],
                val_f(val) {return val },
                validator_f(val) {return validator_number_fb(val)}},
            qt_cost_c : {
                oldNames_as :       ["cost"],
                val_f(val)          {return new FB_Cost(val)},
                validator_f(val)    {return true}},

            qt_couponId_uid:{
                oldNames_as :       [],
                val_f(val)          {return val},
                validator_f(val)    {return validator_null_fb(val) || validator_string_fb(val)}},
            qt_discountPercentage_n:{
                oldNames_as :       [],
                val_f(val)          {return val!=null ? val : 0},
                validator_f(val)    {return validator_number_fb(val)}},

            qt_agentId_uid:{
                oldNames_as :       [],
                val_f(val)          {return val},
                validator_f(val)    {return validator_string_fb(val) || validator_null_fb(val)}},
            qt_creatorText_s:{
                oldNames_as :       [],
                val_f(val)          {return val},
                validator_f(val)    {return validator_string_fb(val) || validator_null_fb(val)}},


        }, FBObj)
    }

    qt_m_chargeDate_ft(){
        for(let i in this.qt_history_ac) {
            let qt_history_c = this.qt_history_ac[i]

            if(qt_history_c.qth_actions_e === enum_questTicketActions.charge){
                return qt_history_c.qth_timestamp_t
            }
        }
        return null
    }
    qt_m_joinedPlayersNum_fn(){
        return Object.values(this.qt_playersJoinDate_byUserId_t).length
    }

    qt_m_canEdit_fb(){

        let now_d = new Date()

        let ticketEditableDate_start_d = new Date(this.qt_saleDate_t)
        ticketEditableDate_start_d.setDate(1)
        ticketEditableDate_start_d.setHours(0)
        ticketEditableDate_start_d.setMinutes(0)
        ticketEditableDate_start_d.setSeconds(1)

        let saleMonth_n = new Date(this.qt_saleDate_t).getMonth()
        let ticketEditableDate_end_d = new Date(this.qt_saleDate_t)
        ticketEditableDate_end_d.setMonth(saleMonth_n+1)
        ticketEditableDate_end_d.setDate(9)
        ticketEditableDate_end_d.setHours(0)
        ticketEditableDate_end_d.setMinutes(0)
        ticketEditableDate_end_d.setSeconds(1)


        return ticketEditableDate_start_d.getTime() <= now_d.getTime()
            && now_d.getTime() <= ticketEditableDate_end_d.getTime()

    }

    static qt_ms_calculateCreatorUsageCost_fn(totalTicketsSlots_n){

        let leftTickets_n = totalTicketsSlots_n
        let tickets_3$ = 0
        let tickets_2$ = 0
        let tickets_1$ = 0

        // free
        leftTickets_n = leftTickets_n - enum_minMonthlySlotsTicketsPricing.firstPlan_n

        // 3$
        let gapSecondPlan_n = enum_minMonthlySlotsTicketsPricing.secondPlan_n - enum_minMonthlySlotsTicketsPricing.firstPlan_n
        tickets_3$ = leftTickets_n>gapSecondPlan_n ? gapSecondPlan_n : leftTickets_n>0 ? leftTickets_n : 0
        leftTickets_n-=gapSecondPlan_n

        // 2$
        let gapThirdPlan_n = enum_minMonthlySlotsTicketsPricing.thirdPlan_n - enum_minMonthlySlotsTicketsPricing.secondPlan_n
        tickets_2$ = leftTickets_n>gapThirdPlan_n ? gapThirdPlan_n : leftTickets_n>0 ? leftTickets_n : 0
        leftTickets_n-=gapThirdPlan_n

        // 1$
        tickets_1$ = leftTickets_n>0 ? leftTickets_n : 0

        return tickets_3$*3+tickets_2$*2+tickets_1$*1

    }


}
export class FB_QuestTicket_History {

    qth_timestamp_t     ;
    qth_actions_e       ;
    qth_changeSpots_n   ;
    qth_refund_c        ;

    constructor(FBObj) {
        this.qth_timestamp_t    = FBObj.qth_timestamp_t;
        this.qth_actions_e      = FBObj.qth_actions_e;
        this.qth_changeSpots_n  = FBObj.qth_changeSpots_n;
        this.qth_refund_c       = FBObj.qth_refund_c ? new FB_Cost(FBObj.qth_refund_c) : null ;
    }
}

// FB_QuestEvent
export class FB_QuestEvent {

    qev_startingDate_t 
    qev_eventId_uid 
    qev_name_byLangCode_s 
    qev_supportedLangCodes_ae 
    qev_defaultLang_e 
    qev_durationInMinutes_n 
    qev_imgFile_blc_c 
    qev_startClockType_e

    static qev_l_ticketsStatus_byTicketId_b  = "qev_ticketsStatus_byTicketId_b"

    constructor (FBObj ) {

        if(FBObj.qev_imgFile_blc_c == null && FBObj.qev_imgFile_c != null){
            FBObj.qev_imgFile_blc_c = {}
            obj_forEach_f(FBObj.qev_supportedLangCodes_ae, (langCode_e ) => {
                FBObj.qev_imgFile_blc_c[langCode_e] = FBObj.qev_imgFile_c
            })
        }

        initClass_f('FB_QuestEvent', this, {

            qev_supportedLangCodes_ae       : {
                val_f(val) {return val != null ? Object.values(val) : []},
                validator_f(val) {return validator_enum_array_fb(enum_langCodes, val)}},
            qev_defaultLang_e               : {
                val_f(val) {return val},
                validator_f(val) {return validator_enum_fb(enum_langCodes, val)}},
            qev_name_byLangCode_s           : {
                val_f(val) {return val},
                validator_f(val) {return validator_textByLangCode_fb(val)}},

            qev_startingDate_t              : {
                val_f(val) {return val},
                validator_f(val) {return validator_null_fb(val) || validator_timestamp_fb(val)}},
            qev_emailFinishQuest_blc_s      : {
                val_f(val)          {return val ? val : {}},
                validator_f(val)    {return validator_objTypeof_fb(val, enum_typeof.string)}},
            qev_emailBoughtTicket_blc_s      : {
                val_f(val)          {return val ? val : {}},
                validator_f(val)    {return validator_objTypeof_fb(val, enum_typeof.string)}},

            qev_durationInMinutes_n         : {
                val_f(val) {return val},
                validator_f(val) {return validator_positiveNumber_fb(val)}},
            qev_ticketsStatus_byTicketId_b  : {
                val_f(val) {return val},
                validator_f(val) {return true}},

            qev_questType_e                 : {
                val_f(val) {return val},
                validator_f(val) {return validator_enum_fb(enum_questTypes, val)}},
            qev_questId_uid                 : {
                val_f(val) {return val},
                validator_f(val) {return validator_string_fb(val)}},
            qev_eventId_uid                 : {
                val_f(val) {return val},
                validator_f(val) {return validator_string_fb(val)}},
            qev_creatorId_uid               : {
                val_f(val) {return val},
                validator_f(val) {return validator_string_fb(val)}},

            qev_utcOffSetHours_n            : {
                val_f(val) {return val},
                validator_f(val) {return validator_number_fb(val)}},
            qev_imgFile_blc_c               : {
                val_f(val)          {return obj_map_fo(val,(file ) => {return new FB_File(file)})},
                validator_f(val)    {return validator_objClass_fb(val, FB_File)}},

            qev_playersNum_n                : {
                val_f(val)          {return val != null ? val : 0},
                validator_f(val)    {return validator_number_fb(val)}},
            qev_startClockType_e : {
                oldNames_as       : [],
                val_f(val)          {return validator_enum_fb(enum_questEventStartClockTypes_s, val) ? val : enum_questEventStartClockTypes_s.creatorStartClock},
                validator_f(val)    {return validator_enum_fb(enum_questEventStartClockTypes_s, val)}},
            qev_whiteLabel_c : {
                val_f(val)          {return new FB_WhiteLabel(val || {})},
                validator_f(val)    {return validator_class_fb(val, FB_WhiteLabel)}},
        }, FBObj)

    }


    cm_qev_getName_fs(system_langCode  ){
        let langCode = helper_getDisplayLang_e(system_langCode, this.qev_supportedLangCodes_ae, this.qev_defaultLang_e)
        return this.qev_name_byLangCode_s[langCode]
    }
    qev_cm_getImageFile_c(systemLangCode_e ){
        let langCode_e = helper_getDisplayLang_e(systemLangCode_e, this.qev_supportedLangCodes_ae, this.qev_defaultLang_e)
        return this.qev_imgFile_blc_c[langCode_e]
    }
    static qev_m_s_uniqueKey_s({questType_e, questId_uid, eventId_uid}){
        return questType_e + "_" + questId_uid + "_" + eventId_uid
    }

}

// FB_SendEmail
export class FB_SendEmail {

    se_sendToEmail_s ;
    se_title_s      ;
    se_message_s    ;

    constructor (FBObj) {
        initClass_f('FB_SendEmail', this, {
            se_sendToEmail_s : {
                oldNames_as : [],
                val_f       : (val) => {return val != null ? val : ""},
                validator_f : (val) => {return validator_string_fb(val)}},

            se_title_s : {
                oldNames_as : [],
                val_f       : (val) => {return val != null ? val : ""},
                validator_f : (val) => {return validator_string_fb(val)}},

            se_message_s : {
                oldNames_as : [],
                val_f       : (val) => {return val != null ? val : ""},
                validator_f : (val) => {return validator_string_fb(val)}},

        }, FBObj)

    }
}

// FB_QuestDiscountCoupon
export class FB_QuestDiscountCoupon {

    newDiscountCoupon_percentage_n
    qdc_couponCode_s

    static qdc_l_couponCode_s  = 'qdc_couponCode_s'


    constructor(FBObj ) {

        initClass_f('FB_QuestDiscountCoupon', this, {
            qdc_questId_uid: {
                val_f       (val ) {return val},
                validator_f (val ) {return validator_string_fb(val)}
            },
            qdc_questType_e: {
                val_f       (val) {return val},
                validator_f (val ) {return validator_enum_fb(enum_questTypes, val)}
            },
            qdc_couponId_uid: {
                val_f       (val) {return val},
                validator_f (val) {return validator_string_fb(val)}
            },
            qbc_createdTime_t:{
                val_f       (val) {return val ? val : (new Date()).getTime()},
                validator_f (val) {return validator_timestamp_fb(val)}
            },

            qdc_couponCode_s: {
                val_f       (val) {return val},
                validator_f (val) {return validator_string_fb(val)}
            },
            qdc_discountPercentage_n: {
                val_f       (val) {return val == null ? 15 : val},
                validator_f (val) {return validator_number_fb(val)}
            },

            qdc_active_b: {
                val_f       (val) {return val ? val : false},
                validator_f (val) {return validator_boolean_fb(val)}
            },

            qdc_spots_n: {
                val_f       (val) {return val == null ? 5 : val},
                validator_f (val) {return validator_number_fb(val)}
            },
            qdc_creatorCoupon_b : {
                val_f       (val) {return val == null ? false : val},
                validator_f (val) {return validator_boolean_fb(val)}
            },
            qdc_history_byTimeStamp_c: {
                val_f       (val) {return val == null ? {} : obj_map_fo(val ,(item) => {return new FB_QuestDiscountCoupon_History(item)})},
                validator_f (val) {return validator_objClass_fb(val, FB_QuestDiscountCoupon_History)}
            },
        }, FBObj)
    }


}

// FB_QuestDiscountCoupon
export class FB_QuestDiscountCoupon_History {

    qdch_playerId_uid
    qdch_timestamp_t
    qbch_eventId_uid
    qdch_status_e

    constructor (FBObj) {

        initClass_f('FB_QuestDiscountCoupon_History', this, {
            qdch_playerId_uid: {
                val_f       (val) {return val},
                validator_f (val) {return validator_string_fb(val)}},
            qdch_timestamp_t: {
                val_f       (val) {return val},
                validator_f (val) {return validator_timestamp_fb(val)}},
            qbch_eventId_uid: {
                val_f       (val) {return val},
                validator_f (val) {return validator_null_fb(val) || validator_string_fb(val)}},
            qdch_status_e: {
                val_f       (val) {return val},
                validator_f (val) {return validator_enum_fb(enum_questDiscountCouponHistory_status, val)}},
        }, FBObj)
    }


}

// FB_QuestReview
export class FB_QuestReview {

    qr_questId_uid
    qr_questType_e
    qr_eventId_uid
    qr_reviewerId_uid
    qr_timestamp_t

    qr_overallRating_n
    qr_difficulty_n

    qr_publicFeedback_s
    qr_privateFeedback_n

    constructor(FBObj) {

        initClass_f('FB_QuestReview', this, {

            qr_questId_uid: {
                val_f(val) {return val},
                validator_f(val) {return validator_typeOf_fb(val, enum_typeof.string)}
            },
            qr_questType_e: {
                val_f(val) {return val},
                validator_f(val) {return validator_enum_fb(enum_questTypes, val)}
            },
            qr_eventId_uid: {
                val_f(val) {return val},
                validator_f(val) {return validator_typeOf_fb(val, enum_typeof.string)}
            },
            qr_timestamp_t: {
                val_f(val) {return val},
                validator_f(val) {return validator_typeOf_fb(val, enum_typeof.number)}
            },
            qr_reviewerId_uid: {
                val_f(val) {return val},
                validator_f(val) {return validator_typeOf_fb(val, enum_typeof.string)}
            },

            qr_overallRating_n: {
                val_f(val) {return val ? val : null},
                validator_f(val) {return validator_number_fb(val) || validator_null_fb(val)}
            },
            qr_difficulty_n: {
                val_f(val) {return val ? val : null},
                validator_f(val) {return validator_number_fb(val) || validator_null_fb(val)}
            },

            qr_publicFeedback_s: {
                val_f(val) {return val ? val : ''},
                validator_f(val) {return validator_typeOf_fb(val, enum_typeof.string)}
            },
            qr_privateFeedback_n: {
                val_f(val) {return val ? val : ''},
                validator_f(val) {return validator_typeOf_fb(val, enum_typeof.string)}
            },


        }, FBObj)

    }

}
export class FB_LastQuestReviewPointer {

    static lqrp_l_timestamp_t = "lqrp_timestamp_t"

    constructor(FBObj) {

        initClass_f('FB_LastQuestReviewPointer', this, {

            lqrp_questId_uid: {
                val_f(val) {return val},
                validator_f(val) {return validator_typeOf_fb(val, enum_typeof.string)}
            },
            lqrp_questType_e: {
                val_f(val) {return val},
                validator_f(val) {return validator_enum_fb(enum_questTypes, val)}
            },
            lqrp_timestamp_t: {
                val_f(val) {return val},
                validator_f(val) {return validator_typeOf_fb(val, enum_typeof.number)}
            },
            lqrp_reviewerId_uid: {
                val_f(val) {return val},
                validator_f(val) {return validator_typeOf_fb(val, enum_typeof.string)}
            },
        }, FBObj)

    }
}

// FB_Point
export class FB_MapPoint{

    static mp_l_lat_n = "mp_lat_n"
    static mp_l_lng_n = "mp_lng_n"

    constructor(FBObj){

        initClass_f(
            'FB_Point',
            this,
            {
                mp_lat_n: {
                    oldNames_as     : ['lat'],
                    val_f           : (val) => {return val != null ? val : 32.0572993886993},
                    validator_f     : (val) => {return validator_number_fb(val)}
                },
                mp_lng_n: {
                    oldNames_as     : ['lng'],
                    val_f           : (val) => {return val != null ? val : 34.87119356213191},
                    validator_f     : (val) => {return validator_number_fb(val)}
                },
                mp_radiusMaters_n: {
                    oldNames_as     : [],
                    val_f           : (val) => {return val ? val : 30},
                    validator_f     : (val) => {return validator_number_fb(val)}
                },
            }, FBObj)

    }

}

// FB_StoreChat
export class FB_StoreChat{

    sc_creatorId_uid
    sc_playerId_uid
    sc_lastMessage_c
    sc_playerUnreadMsgCount_n

    static sc_l_playerId_uid = "sc_playerId_uid"
    static sc_l_creatorId_uid = "sc_creatorId_uid"


    constructor(FBObj){

        initClass_f(
            'FB_StoreChat',
            this,
            {
                sc_creatorId_uid: {
                    oldNames_as     : [],
                    val_f           : (val) => {return val},
                    validator_f     : (val) => {return validator_string_fb(val)}
                },
                sc_playerId_uid: {
                    oldNames_as     : ['sc_senderId_uid'],
                    val_f           : (val) => {return val},
                    validator_f     : (val) => {return validator_string_fb(val)}
                },
                sc_lastMessage_c: {
                    oldNames_as     : [],
                    val_f           : (val) => {return val ? new FB_Message(val) : null},
                    validator_f     : (val) => {return validator_null_fb(val) || validator_class_fb(val, FB_Message)}
                },
                sc_creatorUnreadMsgCount_n: {
                    val_f           : (val) => {return val ? val : 0},
                    validator_f     : (val) => {return validator_number_fb(val)}
                },
                sc_playerUnreadMsgCount_n: {
                    val_f           : (val) => {return val ? val : 0},
                    validator_f     : (val) => {return validator_number_fb(val)}
                },
            }, FBObj)
    }

    sc_m_getId_s(){
        return `${this.sc_creatorId_uid}_${this.sc_playerId_uid}`
    }

    static sc_m_s_getStoreChatWithId_c(id_s){

        if(id_s == null){
            return null
        }

        let userIds_as = id_s.split("_")

        if(userIds_as.length != 2){
            return null
        }

        return new FB_StoreChat({
            sc_creatorId_uid : userIds_as[0],
            sc_playerId_uid : userIds_as[1],
        })
    }

}

// FB_StoreChatQuestionAndAnswers
export class FB_StoreChatCreatorMsg {

    sccm_openingMsg_blc_s

    constructor(FBObj){

        initClass_f(
            'FB_StoreChatCreatorMsg',
            this,
            {
                sccm_questId_uid: {
                    oldNames_as     : [],
                    val_f           : (val) => {return val},
                    validator_f     : (val) => {return validator_string_fb(val)}
                },
                sccm_questType_e : {
                    oldNames_as     : [],
                    val_f           : (val) => {return val},
                    validator_f     : (val ) => {return validator_enum_fb(enum_questTypes, val)}
                },
                sccm_openingMsg_blc_s: {
                    oldNames_as     : [],
                    val_f           : (val) => {return val ? val : ass_strings.sentence_CreatorDefaultMsg},
                    validator_f     : (val) => {return validator_objValStr_fb(val) && validator_objKeys_fb(val, enum_langCodes)}
                },
                sccm_questionAnswers_blc_ac: {
                    oldNames_as     : [],
                    val_f           : (val) => {
                        return obj_mapValues_fo(enum_langCodes, (langCode_e) => {
                            return val && val[langCode_e] ? val[langCode_e].map((questionAnswers_o) => new FB_StoreChatCreatorMsg_QuestionAndAnswers(questionAnswers_o)) : []
                        })
                    },
                    validator_f     : (val) => {return validator_obj_fb(val) && validator_objKeys_fb(val, enum_langCodes)}
                },
            }, FBObj)
    }

}
export class FB_StoreChatCreatorMsg_QuestionAndAnswers {
    constructor(FBObj){

        initClass_f(
            'FB_StoreChatCreatorMsg_QuestionAndAnswers',
            this,
            {
                sccm_qa_question_s: {
                    oldNames_as     : [],
                    val_f           : (val) => {return val},
                    validator_f     : (val) => {return validator_string_fb(val)}
                },
                sccm_qa_answer_s : {
                    oldNames_as     : [],
                    val_f           : (val) => {return val},
                    validator_f     : (val) => {return validator_string_fb(val)}
                },
            }, FBObj)
    }

}


// FB_Message
export class FB_Message extends FB_WrapperServerReceived{

    static ms_l_translate_blc_s = 'ms_translate_blc_s'
    static ms_l_receiveMsg_byUserId_b = 'ms_receiveMsg_byUserId_b'
    static ms_l_readMsg_byUserId_b = 'ms_readMsg_byUserId_b'

    ms_sendTime_n

    constructor (FBObj) {
        super(FBObj)

        initClass_f(
            'FB_Message',
            this,
            {
                ms_sendTime_n: {
                    oldNames_as     : ['sendTime'],
                    val_f           : (val) => {return val ? val : 0},
                    validator_f     : (val) => {return validator_number_fb(val)}
                },
                ms_senderId_uid: {
                    oldNames_as     : ['senderId'],
                    val_f           : (val) => {return val },
                    validator_f     : (val) => {return validator_string_fb(val)}
                },
                ms_text_s: {
                    oldNames_as     : ['text'],
                    val_f           : (str) => {return str},
                    validator_f     : (str) => {return validator_string_fb(str)}
                },
                ms_readMsg_byUserId_b: {
                    oldNames_as     : ['readByUserId'],
                    val_f           : (obj) => {return obj ? obj : {}},
                    validator_f     : (obj) => {return validator_objTypeof_fb(obj, enum_typeof.boolean)}
                },
                ms_receiveMsg_byUserId_b: {
                    oldNames_as     : ['receiveByUserId'],
                    val_f           : (obj) => {return obj ? obj : {}},
                    validator_f     : (obj) => {return validator_objTypeof_fb(obj, enum_typeof.boolean)}
                },
                ms_langCode_e: {
                    oldNames_as     : [],
                    val_f           : (val) => {return val ? val : null},
                    validator_f     : (val) => {return validator_null_fb(val) || validator_string_fb(val)}
                },
                ms_translate_blc_s:{
                    oldNames_as     : [],
                    val_f           : (obj) => {return obj ? obj : {}},
                    validator_f     : (obj) => {return validator_objTypeof_fb(obj, enum_typeof.string) && validator_onjKeysByEnumVal_fb(obj, enum_langCodes)}
                },
            }, FBObj)

    }

}

// FB_TqInfo
export class FB_ServerCurrentVersion {

    svi_webVersion_s;
    svi_androidVersion_s
    svi_iosVersion_s

    constructor(FBObj) {

        initClass_f(
            'FB_ServerCurrentVersion',
            this, {
                svi_webVersion_s: {
                    val_f(val) {
                        return val
                    },
                    validator_f(val) {
                        return validator_string_fb(val)
                    }
                },
                svi_androidVersion_s: {
                    val_f(val) {
                        return val
                    },
                    validator_f(val) {
                        return validator_string_fb(val)
                    }
                },
                svi_iosVersion_s: {
                    val_f(val) {
                        return val
                    },
                    validator_f(val) {
                        return validator_string_fb(val)
                    }
                },
            }, FBObj)
    }

    svi_m_newerWebVersion_f(oldVersion_s) {
        let oldSplitVersions_an = oldVersion_s.split(".").map(ver_s => parseInt(ver_s))
        let newSplitVersions_an = this.svi_webVersion_s.split(".").map(ver_s => parseInt(ver_s))

        for (let i = 0; i < newSplitVersions_an.length; i++) {
            if (oldSplitVersions_an[i] == null || newSplitVersions_an[i] > oldSplitVersions_an[i]) {
                return true
            } else if (newSplitVersions_an[i] < oldSplitVersions_an[i]) {
                return false
            }
        }

        return false

    }
} // FB_LocalStorageUpdateMulti
// FB_TqInfod
export class FB_AndroidInfo {

    ai_versionName_s

    constructor(FBObj) {

        initClass_f(
            'FB_AndroidInfo',
            this, {
                ai_packageName_s: {
                    val_f(val) {
                        return val
                    },
                    validator_f(val) {
                        return validator_string_fb(val)
                    }
                },
                ai_versionName_s: {
                    val_f(val) {
                        return val
                    },
                    validator_f(val) {
                        return validator_string_fb(val)
                    }
                },
            }, FBObj)
    }
}

// FB_TqInfo
export class FB_TqInfo {

    constructor(FBObj) {

        initClass_f(
            'FB_TqInfo',
            this, {
                ti_totalActiveQuests_n: {
                    val_f(val) {
                        return val ? val : 5
                    },
                    validator_f(val) {
                        return validator_number_fb(val)
                    }
                },
                ti_totalEvents_n: {
                    val_f(val) {
                        return val ? val : 100
                    },
                    validator_f(val) {
                        return validator_number_fb(val)
                    }
                },
                ti_totalUsers_n: {
                    val_f(val) {
                        return val ? val : 800
                    },
                    validator_f(val) {
                        return validator_number_fb(val)
                    }
                },

            }, FBObj)
    }
}

// FB_QuestPointer
export class FB_QuestPointer {
    constructor(FBObj) {

        initClass_f('FB_QuestPointer' + FBObj.qp_questId_uid, this, {
            qp_questId_uid: {
                oldNames_as: ["ucq_questId_uid"],
                val_f(val) {return val},
                validator_f(val) {return validator_string_fb(val)}
            },
            qp_questType_e: {
                oldNames_as: ["ucq_questType_e"],
                val_f(val) {return val},
                validator_f(val) {return validator_enum_fb(enum_questTypes, val)}
            },
        }, FBObj)
    }
}

// FB_SavedMessages
export class FB_SavedMessages {
    constructor(FBObj) {

        initClass_f('FB_SavedMessages', this, {
            sm_title_s: {
                oldNames_as: [],
                val_f(val) {
                    return val
                },
                validator_f(val) {
                    return validator_string_fb(val)
                }
            },
            sm_text_s: {
                oldNames_as: [],
                val_f(val) {
                    return val
                },
                validator_f(val) {
                    return validator_string_fb(val)
                }
            },
            sm_timestamp_t: {
                oldNames_as: [],
                val_f(val) {
                    return val
                },
                validator_f(val) {
                    return validator_timestamp_fb(val)
                }
            },
        }, FBObj)
    }

}

// FB_OsInfo
export class FB_OsInfo {

    constructor(FBObj) {

        initClass_f('FB_OsInfo', this, {
            oi_browserName_s: {
                val_f(val) {
                    return val
                },
                validator_f(val) {
                    return validator_string_fb(val)
                }
            },
            oi_browserVersion_s: {
                val_f(val) {
                    return val
                },
                validator_f(val) {
                    return validator_string_fb(val)
                }
            },
            oi_browserMajorVersion_n: {
                val_f(val) {
                    return val
                },
                validator_f(val) {
                    return true
                }
            },
            oi_osName_s: {
                val_f(val) {
                    return val
                },
                validator_f(val) {
                    return validator_string_fb(val)
                }
            },
            oi_osVersion_s: {
                val_f(val) {
                    return val
                },
                validator_f(val) {
                    return validator_string_fb(val)
                }
            },
            oi_cookies_b: {
                val_f(val) {
                    return val
                },
                validator_f(val) {
                    return validator_typeOf_fb(val, enum_typeof.boolean)
                }
            },
            oi_mobile_b: {
                val_f(val) {
                    return val
                },
                validator_f(val) {
                    return validator_typeOf_fb(val, enum_typeof.boolean)
                }
            },
            oi_screen_s: {
                val_f(val) {
                    return val
                },
                validator_f(val) {
                    return validator_string_fb(val)
                }
            },
        }, FBObj)


    }
}

// PRE_QUESTS_BACKUP
export class FB_QuestBackupInfo {
    constructor(FBObj) {

        initClass_f(
            'FB_QuestBackupInfo',
            this,
            {
                qbi_questType_e: {
                    oldNames_as: [],
                    val_f: (val) => {
                        return val
                    },
                    validator_f: (val) => {
                        return validator_string_fb(val)
                    }
                },
                qbi_questId_uid: {
                    oldNames_as: [],
                    val_f: (val) => {
                        return val
                    },
                    validator_f: (val) => {
                        return validator_string_fb(val)
                    }
                },

                qbi_name_s: {
                    oldNames_as: [],
                    val_f: (val) => {
                        return val
                    },
                    validator_f: (val) => {
                        return validator_string_fb(val)
                    }
                },
                qbi_savedDate_t: {
                    oldNames_as: [],
                    val_f: (val) => {
                        return val
                    },
                    validator_f: (val) => {
                        return validator_null_fb(val) || validator_timestamp_fb(val)
                    }
                },
                qbi_savedByPlayerId_uid: {
                    oldNames_as: [],
                    val_f: (val) => {
                        return val
                    },
                    validator_f: (val) => {
                        return validator_string_fb(val)
                    }
                },
                qbi_questBackupId_uid: {
                    oldNames_as: [],
                    val_f: (val) => {
                        return val
                    },
                    validator_f: (val) => {
                        return validator_null_fb(val) || validator_string_fb
                    }
                },

            }, FBObj)
    }

}

// FB_TeamStatus
export class FB_TeamStatus {

    ts_usedClues_as

    static ts_l_usedClues_as = "ts_usedClues_as"
    static ts_l_cluesLeft_n = "ts_cluesLeft_n"

    constructor(FBObj) {

        initClass_f(
            'FB_TeamStatus',
            this,
            {
                ts_teamId_uid: {
                    oldNames_as: ["teamId"],
                    val_f(val) {
                        return val
                    },
                    validator_f(val) {
                        return validator_string_fb(val)
                    }
                },
                ts_cluesLeft_n: {
                    oldNames_as: ["cluesLeft"],
                    val_f(val) {
                        return val
                    },
                    validator_f(val) {
                        return validator_number_fb(val)
                    }
                },
                ts_skipsLeft_n: {
                    oldNames_as: ["skipsLeft"],
                    val_f(val) {
                        return val
                    },
                    validator_f(val) {
                        return validator_number_fb(val)
                    }
                },
                ts_usedClues_as: {
                    oldNames_as: ["usedClues"],
                    val_f(val) {
                        return val ? Object.values(val) : []
                    },
                    validator_f(val) {
                        return validator_null_fb(val) || validator_array_fb(val)
                    }
                },
                ts_bonusPoints_n: {
                    oldNames_as: [],
                    val_f(val) {
                        return val ? val : 0
                    },
                    validator_f(val) {
                        return validator_number_fb(val)
                    }
                },
            },
            FBObj)
    }

}

// FB_RiddleStatus
export class FB_RiddleStatus {
    rs_unlock_byLockId_c;
    rs_clues_byClueId_c;
    rs_startMissionTime_t;
    rs_lockData_byLockIndex_c
    rs_lockActions_byLockIndex_byTime_c

    static rs_l_riddleId_n = "rs_riddleId_n";
    static rs_l_unlock_byLockId_c = "rs_unlock_byLockId_c";
    static rs_l_clues_byClueId_c = "rs_clues_byClueId_c";
    static rs_l_lockData_byLockIndex_c= "rs_lockData_byLockIndex_c";
    static rs_l_lockActions_byLockIndex_byTime_c= "rs_lockActions_byLockIndex_byTime_c";

    constructor(FBObj) {

        initClass_f(
            'FB_RiddleStatus',
            this,
            {
                rs_riddleId_n: {
                    oldNames_as: [],
                    val_f(val) {
                        return val
                    },
                    validator_f(val) {
                        return validator_number_fb(val)
                    }
                },
                rs_unlock_byLockId_c: {
                    oldNames_as: [],
                    val_f(val) {
                        return val ? obj_map_fo(val, (item) => {
                            return new FB_RiddleStatus_unlockData(item)
                        }) : null
                    },
                    validator_f(val) {
                        return validator_null_fb(val) || validator_objClass_fb(val, FB_RiddleStatus_unlockData)
                    }
                },
                rs_startMissionTime_t: {
                    oldNames_as: [],
                    val_f(val) {
                        return val
                    },
                    validator_f(val) {
                        return validator_null_fb(val) || validator_timestamp_fb(val)
                    }
                },
                rs_clues_byClueId_c: {
                    oldNames_as: [],
                    val_f(val) {
                        return val != null ? obj_map_fo(val, item => {
                            return new FB_RiddleStatus_userAction(item)
                        }) : {}
                    },
                    validator_f(val) {
                        return validator_objClass_fb(val, FB_RiddleStatus_userAction)
                    }
                },
                rs_lockData_byLockIndex_c: {
                    val_f : val =>  val ? obj_map_fo(val, item => new FB_RS_LockData(item)): {},
                    validator_f : val => validator_objClass_fb(val, FB_RS_LockData)
                },
                rs_lockActions_byLockIndex_byTime_c: {
                    val_f : val =>  val ?  obj_map_fo(val, item1 => obj_map_fo(item1, (item2) => new FB_RS_LockActions(item2))) : {},
                    validator_f : val => true},
            },
            FBObj)
    }

    cm_rs_lastUpdateTimestamp_t() {

        let timestamp_t;

        obj_forEach_f(this.rs_unlock_byLockId_c, rs_unlockData_c => {
            if (timestamp_t == null || timestamp_t < rs_unlockData_c.rsud_timestemp_t) {
                timestamp_t = rs_unlockData_c.rsud_timestemp_t
            }
        })

        obj_forEach_f(this.rs_clues_byClueId_c, rs_userAction_c => {
            if (timestamp_t == null || timestamp_t < rs_userAction_c.rsua_timestamp_t) {
                timestamp_t = rs_userAction_c.rsua_timestamp_t
            }
        })

        return timestamp_t;
    }

    cm_rs_locksTotalPoints_n() {

        let score_n = 0;

        obj_forEach_f(this.rs_unlock_byLockId_c, rs_unlockData_c => {
            score_n += rs_unlockData_c.rsud_receivedPoints_n
        })

        obj_forEach_f(this.rs_clues_byClueId_c, rs_cluesDatA_c => {
            score_n -= rs_cluesDatA_c.rsua_pointsWorth_n
        })

        return score_n;
    }

    rs_m_missionTotalTime_t() {
        let lastFinishLockTime_t = 0

        if (obj_size_fn(this.rs_unlock_byLockId_c) === 0 || this.rs_startMissionTime_t == null) {
            return lastFinishLockTime_t
        }

        obj_forEach_f(this.rs_unlock_byLockId_c, (rs_unlockData_c) => {
            if (rs_unlockData_c.rsud_timestemp_t > lastFinishLockTime_t) {
                lastFinishLockTime_t = rs_unlockData_c.rsud_timestemp_t
            }
        })
        return lastFinishLockTime_t - this.rs_startMissionTime_t
    }

    rs_m_finishActionLock_b(lockIndex_n){

        if(!this.rs_lockActions_byLockIndex_byTime_c[lockIndex_n]){
            return false
        }
        
        // at least one right ans
        for(const rs_lockAction_c of Object.values(this.rs_lockActions_byLockIndex_byTime_c[lockIndex_n])){
            if(rs_lockAction_c.rsla_rightAns_b){
                return true
            }
        }

        return false
    }


    rs_m_actionLock_calcPoints_n(lockIndex_n){
        const rs_lockData_c = this.rs_lockData_byLockIndex_c[lockIndex_n]

        let totalPoints = rs_lockData_c.rsld_totalPoints_n
        for(const rs_lockAction_c of Object.values(this.rs_lockActions_byLockIndex_byTime_c[lockIndex_n])){

            if(rs_lockAction_c.rsla_rightAns_b){
                return totalPoints
            }else if(totalPoints < rs_lockData_c.rsld_minPoints_n){
                return rs_lockData_c.rsld_minPoints_n
            }else{
                totalPoints -= rs_lockData_c.rsld_errorPointCost_n
            }
        }
    }

}
export class FB_RiddleStatus_userAction {
    constructor(FBObj) {

        initClass_f(
            'FB_RiddleStatus_userAction',
            this,
            {
                rsua_timestamp_t: {
                    oldNames_as: ["finishDate"],
                    val_f(val) {
                        return val
                    },
                    validator_f(val) {
                        return validator_number_fb(val)
                    }
                },
                rsua_userId_uid: {
                    oldNames_as: ["userId"],
                    val_f(val) {
                        return val
                    },
                    validator_f(val) {
                        return validator_string_fb(val)
                    }
                },
                rsua_pointsWorth_n: {
                    oldNames_as: [],
                    val_f(val) {
                        return val ? val : 0
                    },
                    validator_f(val) {
                        return validator_number_fb(val)
                    }
                },
            },
            FBObj)

    }
}
export class FB_RiddleStatus_unlockData extends FB_WrapperServerReceived{

    rsud_lockState_e;
    rsud_lockType_e;

    static rsud_l_lockType_e = "rsud_lockType_e";
    static rsud_l_lockState_e = "rsud_lockState_e";
    static rsud_l_timestemp_t = "rsud_timestemp_t";

    constructor(FBObj) {
        super(FBObj)

        initClass_f(
            'FB_RiddleStatus_unlockData',
            this,
            {
                rsud_lockType_e: {
                    oldNames_as: [],
                    val_f(val) {return val},
                    validator_f(val) { return validator_enum_fb(enum_lockTypes, val) }
                },
                rsud_timestemp_t: {
                    oldNames_as: ["finishDate"],
                    val_f(val) {
                        return val ? val : date_nowTime_t()
                    },
                    validator_f(val) {
                        return validator_number_fb(val)
                    }
                },
                rsud_userId_uid: {
                    oldNames_as: ["userId"],
                    val_f(val) {
                        return val
                    },
                    validator_f(val) {
                        return validator_null_fb(val) || validator_string_fb(val)
                    }
                },
                rsud_quizUserAns_byQuestionIndex_as: {
                    oldNames_as: [],
                    val_f(val) {
                        return val ? val : {0: {}}
                    },
                    validator_f(val) {
                        return true
                    }
                },
                rsud_imgFile_c: {
                    oldNames_as: [],
                    val_f(val) {
                        return val ? new FB_File(val) : null
                    },
                    validator_f(val) {
                        return true
                    }
                },
                rsud_lockState_e: {
                    oldNames_as: [],
                    val_f(val) {
                        return val ? val : enum_lockState.waitingToApprove
                    },
                    validator_f(val) {
                        return validator_enum_fb(enum_lockState, val)
                    }
                },
                rsud_skip_b: {
                    oldNames_as: [],
                    val_f(val) {
                        return val ? val : false
                    },
                    validator_f(val) {
                        return validator_typeOf_fb(val, enum_typeof.boolean)
                    }
                },
                rsud_receivedPoints_n: {
                    oldNames_as: [],
                    val_f(val) {
                        return val != null ? val : 0
                    },
                    validator_f(val) {
                        return validator_number_fb(val)
                    }
                },
            },
            FBObj)
    }

}
export class FB_RS_LockData{

    constructor(FBObj){
        initClass_f(
            'FB_RS_LockData',
            this,
            {
                rsld_lockIndex_n: {
                    val_f : val =>  val ? val : date_nowTime_t(),
                    validator_f : val => validator_number_fb(val)},
                rsld_totalPoints_n: {
                    val_f : val =>  val ? val : date_nowTime_t(),
                    validator_f : val => validator_number_fb(val)},
                rsld_minPoints_n: {
                    val_f : val =>  val ? val : date_nowTime_t(),
                    validator_f : val => validator_number_fb(val)},
                rsld_errorPointCost_n: {
                    val_f : val =>  val ? val : date_nowTime_t(),
                    validator_f : val => validator_number_fb(val)},
            },
            FBObj)
    }

}
export class FB_RS_LockActions {

    constructor(FBObj){
        initClass_f(
            'FB_RS_LockActions',
            this,
            {
                rsla_lockIndex_n: {
                    val_f : val =>  val,
                    validator_f : val => validator_number_fb(val)},
                rsla_timestamp_t: {
                    val_f : val =>  val ? val : date_nowTime_t(),
                    validator_f : val => validator_number_fb(val)},
                rsla_userId_uid: {
                    val_f : val => val,
                    validator_f : val => validator_string_fb(val)},
                rsla_geoLocation_c: {
                    val_f : val => val ? new FB_UserGeoLocation(val) : null,
                    validator_f(val) {return validator_null_fb(val) || validator_class_fb(val, FB_UserGeoLocation)}},
                rsla_rightAns_b: {
                    val_f : val => val,
                    validator_f : val => validator_boolean_fb(val)},
            },
            FBObj)
    }

}

// ClassFB_UserGeoLocation
export class FB_UserGeoLocation {

    _ugl_accuracy_n;

    constructor(FBObj) {

        initClass_f(
            'FB_UserGeoLocation',
            this,
            {
                ugl_userId_uid: {
                    oldNames_as: ["userId_uid"],
                    val_f(val) {
                        return val
                    },
                    validator_f(val) {
                        return validator_null_fb(val) || validator_typeOf_fb(val, enum_typeof.string)
                    }
                },
                ugl_altitude_n: {
                    oldNames_as: ["altitude_n"],
                    val_f(val) {
                        return val
                    },
                    validator_f(val) {
                        return validator_null_fb(val) || validator_typeOf_fb(val, enum_typeof.number)
                    }
                },
                ugl_altitudeAccuracy_n: {
                    oldNames_as: ["altitudeAccuracy_n"],
                    val_f(val) {
                        return val
                    },
                    validator_f(val) {
                        return validator_null_fb(val) || validator_typeOf_fb(val, enum_typeof.number)
                    }
                },
                ugl_heading_n: {
                    oldNames_as: ["heading_n"],
                    val_f(val) {
                        return val
                    },
                    validator_f(val) {
                        return validator_null_fb(val) || validator_typeOf_fb(val, enum_typeof.number)
                    }
                },
                ugl_latitude_n: {
                    oldNames_as: ["latitude_n"],
                    val_f(val) {
                        return val != null ? val : 0
                    },
                    validator_f(val) {
                        return validator_typeOf_fb(val, enum_typeof.number)
                    }
                },
                ugl_longitude_n: {
                    oldNames_as: ["longitude_n"],
                    val_f(val) {
                        return val
                    },
                    validator_f(val) {
                        return validator_typeOf_fb(val, enum_typeof.number)
                    }
                },
                ugl_speed_n: {
                    oldNames_as: ["speed_n"],
                    val_f(val) {
                        return val
                    },
                    validator_f(val) {
                        return validator_null_fb(val) || validator_typeOf_fb(val, enum_typeof.number)
                    }
                },
                ugl_timestamp_t: {
                    oldNames_as: ["timestamp_t"],
                    val_f(val) {
                        return val
                    },
                    validator_f(val) {
                        return validator_typeOf_fb(val, enum_typeof.number)
                    }
                },
            },
            FBObj)


        this.ugl_accuracy_n = FBObj._ugl_accuracy_n
    }

    set ugl_accuracy_n(val) {

        if (!validator_typeOf_fb(val, enum_typeof.number)) {
            console.log("set ugl_accuracy_n error")
            this._ugl_accuracy_n = 0;
            return;
        }

        this._ugl_accuracy_n = val

    }

    get ugl_accuracy_n() {
        if (this._ugl_accuracy_n > 400) {
            return 400
        }
        return this._ugl_accuracy_n
    }

    ugl_f_accurateGeoLocation_b(){
        return this.ugl_accuracy_n < 400
    }

}

// FB_EncryptValue
export class FB_EncryptValue {

    _enc_value_s
    enc_version_n

    constructor(FBObj) {

        // handle old version
        if (validator_string_fb(FBObj)) {
            FBObj = {
                _enc_value_s: FBObj,
                enc_version_n: 0 // value is not encrypted
            }
        }

        initClass_f(
            'FB_EncryptValue',
            this,
            {
                _enc_value_s: {
                    val_f: (val) => val ? val : '',
                    validator_f: (val) => validator_string_fb(val)
                },
                enc_version_n: {
                    val_f: (val) => val ? val : 0,
                    validator_f: (val) => validator_number_fb(val)
                },
            },
            FBObj)

        // handle old version
        if (this.enc_version_n === 0) {
            this.enc_version_n = 1
            this.enc_value_s = this._enc_value_s
        }

    }

    set enc_value_s(value_s) {
        this._enc_value_s = crypto_encrypt_fs(value_s)
    }

    get enc_value_s() {
        return crypto_decrypt_fs(this._enc_value_s)
    }
}

// FB_mapData
export class FB_MapData {

    md_center_c
    md_zoom_n
    md_polygons_ac
    md_overlayImages_ac

    constructor(FBObj) {


        // if (!validator_array_fb(this.polygons)) {
        //     this.polygons = FBObj.polygons ? Object.values(FBObj.polygons) : []
        // }else{
        //     this.polygons = FBObj.polygons ? FBObj.polygons : []
        // }

        // todo : remove this
        if (FBObj.polygons != null) {
            FBObj.polygons = FBObj.polygons.map(polygon_byIndex_o => {
                return Object.values(polygon_byIndex_o)
            })
        }

        // todo: remove this
        if (FBObj.md_polygons_a_byIndex_c != null) {
            FBObj.md_polygons_a_byIndex_c = FBObj.md_polygons_a_byIndex_c.map(polygon_byIndex_o => {
                return new FB_MapData_Polygon({
                    mdp_points_byIndex_c: polygon_byIndex_o,
                })
            })
        }

        initClass_f(
            'FB_MapData',
            this,
            {
                md_zoom_n: {
                    oldNames_as: ['zoom'],
                    val_f: (val) => {return val ? val : 10},
                    validator_f: (val) => {return validator_number_fb(val)}},
                md_center_c: {
                    oldNames_as: ['center'],
                    val_f: (val) => {return val ? new FB_MapPoint(val) : new FB_MapPoint({})},
                    validator_f: (val) => {return validator_class_fb(val, FB_MapPoint)}
                },
                md_overlayImages_ac: {
                    oldNames_as: [],
                    val_f: (arr) => {return arr ? arr.map(md_overlayImage => new FB_MapData_OverlayImage(md_overlayImage)) : []},
                    validator_f: (arr) => {return validator_arrayClass_fb(arr, FB_MapData_OverlayImage)}
                },
                md_polygons_ac: {
                    oldNames_as: ['polygons', 'md_polygons_aao', 'md_polygons_a_byIndex_c'],
                    val_f: (arr_ao) => {
                        return arr_ao
                            ? Object.values(arr_ao).map((polygon_c) => {
                                return new FB_MapData_Polygon(polygon_c)
                            })
                            : []
                    },
                    validator_f: (arr_ao) => {return validator_arrayClass_fb(arr_ao, FB_MapData_Polygon)}
                },
            }, FBObj)
    }

}
export class FB_MapData_Polygon {
    mdp_points_byIndex_c

    constructor(FBObj) {

        initClass_f(
            'FB_MapData_Polygon',
            this,
            {
                mdp_points_byIndex_c: {
                    oldNames_as: [],
                    val_f: (val) => {
                        return obj_map_fo(val, (point_o) => {
                            return new FB_MapPoint(point_o)
                        })
                    },
                    validator_f: (val) => {
                        return validator_objClass_fb(val, FB_MapPoint)
                    }
                },
                mdp_color_s: {
                    oldNames_as: [],
                    val_f: (val) => {
                        return val ? val : 'purple'
                    },
                    validator_f: (val) => {
                        return validator_string_fb(val)
                    }
                },
                mdp_strokeWidth_n: {
                    oldNames_as: [],
                    val_f: (val) => {
                        return val != null ? val : 1
                    },
                    validator_f: (val) => {
                        return validator_number_fb(val)
                    }
                },
                mdp_fillOpacity_n: {
                    oldNames_as: [],
                    val_f: (val) => {
                        return val != null ? val : 0.2
                    },
                    validator_f: (val) => {
                        return validator_number_fb(val)
                    }
                },
                mdp_name_s: {
                    oldNames_as: [],
                    val_f: (val) => {
                        return val != null ? val : null
                    },
                    validator_f: (val) => {
                        return validator_null_fb(val) || validator_string_fb(val)
                    }
                },

            }, FBObj)
    }

}
export class FB_MapData_OverlayImage {
    constructor(FBObj) {

        initClass_f(
            'FB_MapData_OverlayImage',
            this,
            {
                mdoi_northEast_c: {
                    oldNames_as: [],
                    val_f(val) {
                        return val ? new FB_MapPoint(val) : new FB_MapPoint({})
                    },
                    validator_f(val) {
                        return validator_class_fb(val, FB_MapPoint)
                    }
                },
                mdoi_southWest_c: {
                    oldNames_as: [],
                    val_f(val) {
                        return val ? new FB_MapPoint(val) : new FB_MapPoint({})
                    },
                    validator_f(val) {
                        return validator_class_fb(val, FB_MapPoint)
                    }
                },
                mdoi_imageUrl_s: {
                    oldNames_as: [],
                    val_f: (val) => {
                        return val
                    },
                    validator_f: (val) => {
                        return validator_string_fb(val)
                    }
                },

            }, FBObj)
    }

}

// FB_TeamPlayerInfo
export class FB_TeamPlayerInfo {
    constructor(FBObj) {

        initClass_f(
            'FB_TeamPlayerInfo',
            this,
            {
                pmi_batteryLevel_n: {
                    oldNames_as: [],
                    val_f: (val) => {
                        return val != null ? val : -1
                    },
                    validator_f: (val) => {
                        return validator_number_fb(val)
                    }
                },
                pmi_walkInMeters_n: {
                    oldNames_as: [],
                    val_f: (val) => {
                        return val != null ? val : 0
                    },
                    validator_f: (val) => {
                        return validator_number_fb(val)
                    }
                },
            }, FBObj)
    }
}

// FB_LocalStorageUpdateMulti
export class FB_LocalStorageUpdateMulti {
    constructor(FBObj) {

        initClass_f(
            'FB_LocalStorageUpdateMulti',
            this,
            {
                lsum_data_o: {
                    oldNames_as: [],
                    val_f: (val) => val,
                    validator_f: (val) => true
                },
                lsum_path_as: {
                    oldNames_as: [],
                    val_f: (val) => {return val},
                    validator_f: (val) => {return validator_array_fb(val)}
                },
                lsum_query_os: {
                    oldNames_as: [],
                    val_f: (val) => {return val != null ? val : {}},
                    validator_f: (val) => {return validator_objValStr_fb(val)}
                },
            }, FBObj)
    }

}

// FB_ActiveQuests
export class FB_PaymentActiveQuest {
    constructor(FBObj) {

        initClass_f(
            'FB_PaymentActiveQuest',
            this,
            {
                paq_questId_uid: {
                    oldNames_as: [],
                    val_f: (val) => val,
                    validator_f: (val) => validator_string_fb(val)
                },
                paq_creatorId_uid: {
                    oldNames_as: [],
                    val_f: (val) => val,
                    validator_f: (val) => validator_string_fb(val)
                },
                paq_questType_e: {
                    oldNames_as: [],
                    val_f: (val) => val,
                    validator_f: (val) => validator_enum_fb(enum_questTypes,val)
                },
                paq_endingDate_t: {
                    oldNames_as: [],
                    val_f: (val) => val,
                    validator_f: (val) =>  validator_timestamp_fb(val)
                },
            }, FBObj)
    }

}

// FB_PaymentRequest
export class FB_PaymentRequest {

    pr_id_uid
    pr_creatorId_uid
    pr_paymentCardId_s
    pr_questPointer_c
    pr_currentActiveQuestsPointers_ac
    pr_startingDate_t
    pr_type_e
    pr_autoRenew_b
    pr_status_e
    pr_requestBy_e
    pr_receiptUrl_s

    constructor(FBObj) {
        initClass_f(
            'FB_PaymentRequest',
            this,
            {
                pr_id_uid: {
                    oldNames_as: [],
                    val_f: (val) => val,
                    validator_f: (val) => validator_string_fb(val) || validator_null_fb(val)
                },
               
                pr_creatorId_uid: {
                    oldNames_as: [],
                    val_f: (val) => val,
                    validator_f: (val) => validator_string_fb(val)
                },
                pr_paymentCardId_s: {
                    oldNames_as: [],
                    val_f: (val) => val,
                    validator_f: (val) => validator_string_fb(val)
                },
                pr_questPointer_c: {
                    oldNames_as: [],
                    val_f: (val) => new FB_QuestPointer(val),
                    validator_f: (val) =>  validator_class_fb(val, FB_QuestPointer)
                },
                pr_currentActiveQuestsPointers_ac: {
                    oldNames_as: [],
                    val_f: (val) => val ? val.map(item => new FB_QuestPointer(item)) : [],
                    validator_f: (val) =>  validator_arrayClass_fb(val, FB_QuestPointer)
                },
                pr_startingDate_t: {
                    oldNames_as: [],
                    val_f: (val) => val,
                    validator_f: (val) =>  validator_timestamp_fb(val) || validator_null_fb(val)
                },
                pr_type_e: {
                    oldNames_as: [],
                    val_f: (val) => val,
                        validator_f: (val) =>  validator_enum_fb(enum_subscriptionTypes, val)
                },
                pr_autoRenew_b: {
                    oldNames_as: [],
                    val_f: (val) => val,
                    validator_f: (val) =>  validator_boolean_fb(val)
                },
                pr_status_e: {
                    oldNames_as: [],
                    val_f: (val) => val,
                    validator_f: (val) =>  validator_enum_fb(enum_paymentRequestStatus, val)
                },
                pr_requestBy_e: {
                    oldNames_as: [],
                    val_f: (val) => val,
                    validator_f: (val) =>  validator_enum_fb(enum_paymentRequestBy, val)
                },

                pr_receiptUrl_s: {
                    oldNames_as: [],
                    val_f: (val) => val,
                    validator_f: (val) =>  validator_null_fb(val) || validator_string_fb(val)
                },
            }, FBObj)
    }

    pr_m_questCost_fc(){
        let cost_c = this.pr_m_monthlyCost_fc()

        // yearly discont
        if(this.pr_type_e === enum_subscriptionTypes.yearly){
            cost_c.c_value_n *= 12
        }
        
        // return
        return cost_c

    }

    pr_m_monthlyCost_fc(){
        let value_n = 0
        const totalQuest_n = 1 + this.pr_currentActiveQuestsPointers_ac.length

         // all pricing
         const allPricingPlans_aa = [
            [enum_subPlan_activeQuests.pro, enum_subPlan_costDollars.legend],
            [enum_subPlan_activeQuests.advanced, enum_subPlan_costDollars.pro],
            [enum_subPlan_activeQuests.basic, enum_subPlan_costDollars.advanced],
            [enum_subPlan_activeQuests.free, enum_subPlan_costDollars.basic],
        ]

        // calc
        for(const index_n in allPricingPlans_aa){
            const price_a = allPricingPlans_aa[index_n]
            if(price_a[0] < totalQuest_n){
                value_n = price_a[1]
                break;
            }
        }

        // 
        if(this.pr_type_e === enum_subscriptionTypes.yearly){
            value_n =  (value_n / 100) * 80
        }
        
        return new FB_Cost({
            c_currency_e: enum_costCurrency_n.SHEKEL,
            c_value_n: value_n
        })
        
    }

    pr_m_endingDate_t(){
        const startingDate_d = new Date(this.pr_startingDate_t)
        
        switch(this.pr_type_e){
            case enum_subscriptionTypes.monthly:
                return new Date(startingDate_d.setMonth(startingDate_d.getMonth()+1)).getTime()
            case enum_subscriptionTypes.yearly:
                return new Date(startingDate_d.setFullYear(startingDate_d.getFullYear()+1)).getTime()
        }
        return 
    }
}

// FB_PaymentRenewRequest
export class FB_PaymentRenewRequest {
    constructor(FBObj) {

        initClass_f(
            'FB_PaymentRenewRequest',
            this,
            {
                prr_paymentRequestId_uid: {
                    oldNames_as: [],
                    val_f: (val) => val,
                    validator_f: (val) => validator_string_fb(val)
                },
                prr_creatorId_uid: {
                    oldNames_as: [],
                    val_f: (val) => val,
                    validator_f: (val) => validator_string_fb(val)
                },
                prr_endingDate_t: {
                    oldNames_as: [],
                    val_f: (val) => val,
                    validator_f: (val) =>  validator_timestamp_fb(val)
                },
            }, FBObj)
    }

}


// =========== 3) Slides Data  ==============

// FB_MultiLanguage
export class FB_MultiLanguage {

    ml_langArr_ae
    ml_mainLang_e

    constructor (FBObj ) {

        initClass_f(
            'FB_SlideData',
            this, {
                ml_langArr_ae: {
                    val_f(val)          {return val ? val : [enum_langCodes.english]},
                    validator_f(val)    {return validator_enum_array_fb(enum_langCodes, val)}},
                ml_mainLang_e: {
                    val_f(val)          {return val ? val : enum_langCodes.english },
                    validator_f(val)    {return validator_enum_fb(enum_langCodes, val)}},
            }, FBObj)
    }

    // ml_m_displayLang_fe
    ml_m_displayLang_fe(systemLangCode_e){

        if(this.ml_langArr_ae.indexOf(systemLangCode_e) > -1){
            return systemLangCode_e
        }else {
            return this.ml_mainLang_e
        }
    }
}

// FB_SlidesObj
export class FB_SlidesObj extends FB_MultiLanguage{

    so_slides_blc_ac

    constructor (FBObj ) {
        super(FBObj)

        initClass_f(
            'FB_SlideData',
            this, {
                so_slides_blc_ac: {
                    val_f(val)          {return val ? obj_map_fo(val, (item_ao) => item_ao.map((item_o) => new FB_SlideData(item_o))) : {}},
                    validator_f(val)    {return validator_objKeys_fb(val, enum_langCodes)}},
            }, FBObj)
    }


}

// FB_SlideData
export class FB_SlideData {

    constructor (FBObj ) {

        initClass_f(
            'FB_SlideData',
            this, {
                sd_imageUrl_s: {
                    val_f(val)          {return val},
                    validator_f(val)    {return validator_string_fb(val) || validator_null_fb(val)}},
                sd_title_s: {
                    val_f(val)          {return val ? val : 'Title'},
                    validator_f(val)    {return validator_string_fb(val)}},
                sd_description_s: {
                    val_f(val)          {return val ? val : 'Description'},
                    validator_f(val)    {return validator_string_fb(val)}},
            }, FBObj)
    }

}

// FB_MoreInfo - helpers/features/versions
export class FB_MoreInfo extends FB_SlidesObj{

    constructor(FBObj) {
        super(FBObj)

        initClass_f(
            'FB_MoreInfo',
            this,
            {
                mi_id_uid: {
                    val_f(val) {return val},
                    validator_f(val) {return validator_string_fb(val)}
                },
                mi_lastEdit_t: {
                    val_f(val) {return val},
                    validator_f(val) {return validator_timestamp_fb(val)}
                },

            }, FBObj)

    }


}

// FB_QuestMold
export class FB_QuestMold extends FB_SlidesObj{

    qm_questId_uid
    qm_featuresIds_ae

    constructor (FBObj ) {
        super(FBObj)

        initClass_f(
            'FB_QuestMold',
            this, {
                qm_questId_uid: {
                    val_f(val)          {return val},
                    validator_f(val)    {return validator_string_fb(val)}},
                qm_featuresIds_ae: {
                    val_f(val)          {return val ? val : []},
                    validator_f(val)    {return validator_enum_array_fb(enum_moreInfo_featuresIds_s, val)}},
            }, FBObj)
    }


    qm_m_maxFeaturesPoints_fn(){
        let ans_n = 0

        this.qm_featuresIds_ae.forEach((featureId_uid) => {
            let featureMinPoints_n = enum_featuresMinPoints[featureId_uid]
            if(featureMinPoints_n > ans_n){
                ans_n = featureMinPoints_n
            }
        })

        return ans_n
    }
}

// FB_AdminEmail
export class FB_AdminEmail{

    ae_id_uid
    ae_body_blc_html

    constructor (FBObj ) {

        initClass_f(
            'FB_AdminEmail',
            this,
            {
                ae_id_uid: {
                    oldNames_as     : [],
                    val_f           : (val) => {return  val},
                    validator_f     : (val) => {return validator_string_fb(val)}},
                ae_title_blc_s: {
                    oldNames_as     : [],
                    val_f           : (val) => {return  obj_mapValues_fo(enum_langCodes, (langCode_e) => {return val[langCode_e] ? val[langCode_e] : ''})},
                    validator_f     : (val) => {return validator_objValStr_fb(val) && validator_objKeys_fb(val, enum_langCodes)}},
                ae_body_blc_html : {
                    oldNames_as     : [],
                    val_f           : (val) => {return  obj_mapValues_fo(enum_langCodes, (langCode_e) => {return val[langCode_e] ? val[langCode_e] : ''})},
                    validator_f     : (val) => {return validator_objValStr_fb(val) && validator_objKeys_fb(val, enum_langCodes)}},
            },
            FBObj)
    }

}

// FB_BlogArticle
export class FB_BlogArticle{

    bc_content_blc_c
    ba_langArr_ae

    constructor(FBObj ) {

        if(FBObj.ba_name_blc_s == null && FBObj.fd_name_s != null){
            FBObj.ba_name_blc_s = {'iw' : FBObj.fd_name_s}
        }

        if(FBObj.bc_content_blc_c == null && FBObj.fd_body_c != null){
            FBObj.bc_content_blc_c = {'iw' : FBObj.fd_body_c}
        }

        initClass_f(
            'FB_BlogArticle',
            this,
            {
                ba_mainImage_blc_c :{
                    oldNames_as     : [],
                    val_f           : (val ) => {return val ? obj_map_fo(val, (item_o) => {return new FB_File(item_o)}) : {}},
                    validator_f     : (val ) => {return validator_objClass_fb(val, FB_File)},
                },

                ba_langArr_ae :{
                    oldNames_as     : [],
                    val_f           : (val ) => {return val ? val : []},
                    validator_f     : (val ) => {return validator_enum_array_fb(enum_langCodes, val)},
                },
                ba_mainLang_e : {
                    oldNames_as         : [],
                    val_f(val )          {return val ? val : enum_langCodes.hebrew},
                    validator_f(val )    {return validator_enum_fb(enum_langCodes, val)}},

                ba_articleId_uid: {
                    oldNames_as     : ['fd_forumId_uid'],
                    val_f           : (val ) => {return val },
                    validator_f     : (val ) => {return validator_string_fb(val)}},
                ba_name_blc_s: {
                    oldNames_as     : [],
                    val_f           : (val ) => {return val ? val : {}},
                    validator_f     : (val ) => {return validator_obj_fb(val)}},
                bc_content_blc_c: {
                    oldNames_as     : [],
                    val_f           : (val ) => {return val ? obj_map_fo(val, (wysiwng_o) => {return new FB_Wysiwyg(wysiwng_o)}) : {}},
                    validator_f     : (val ) => {return validator_obj_fb(val)}},
                ba_createdTime_t: {
                    oldNames_as     : [],
                    val_f           : (val ) => {return val ? val : (new Date()).getTime()},
                    validator_f     : (val ) => {return validator_timestamp_fb(val)}},
                ba_lastEditedTime_t: {
                    oldNames_as     : ['fd_lastEditTime_t'],
                    val_f           : (val ) => {return val ? val : (new Date()).getTime()},
                    validator_f     : (val ) => {return validator_timestamp_fb(val)}},
                ba_active_b: {
                    oldNames_as     : [],
                    val_f           : (val ) => {return val ? val : false},
                    validator_f     : (val ) => {return validator_boolean_fb(val)}},
                ba_title_blc_s: {
                    oldNames_as     : [],
                    val_f           : (val ) => {return val ? val : {}},
                    validator_f     : (val ) => {return validator_obj_fb(val)}},
                ba_description_blc_s: {
                    oldNames_as     : [],
                    val_f           : (val ) => {return val ? val : {}},
                    validator_f     : (val ) => {return validator_obj_fb(val)}},

            }, FBObj)
    }

    ba_m_addNewLangCode_f(langCode_e){
        if(this.bc_content_blc_c[langCode_e] == null){
            this.bc_content_blc_c[langCode_e] = new FB_Wysiwyg({})
        }

        this.ba_langArr_ae.push(langCode_e)
    }

}


// =========== 4) Admin ==============

// FB_CreatorMonthlyPaymentStatus
export class FB_CreatorMonthlyPaymentStatus {


    cmps_creatorId_uid
    cmps_month_yyyy_mm_s
    cmps_langCode_e
    cmps_createdTicketsNum_n
    cmps_chargePaymentStatus_e
    cmps_chargePaymentReceiptUrl_s
    cmps_emailBodyHtml_s


    constructor (FBObj ) {


        initClass_f(
            'FB_CreatorMonthlyPaymentStatus',
            this,
            {
                cmps_creatorId_uid: {
                    oldNames_as     : ["acmps_creatorId_uid"],
                    val_f           : (val) => {return  val},
                    validator_f     : (val) => {return validator_string_fb(val)}},
                cmps_creatorEmail_s: {
                    oldNames_as     : [],
                    val_f           : (val) => {return  val},
                    validator_f     : (val) => {return validator_string_fb(val) || validator_null_fb(val)}},
                cmps_month_yyyy_mm_s: {
                    oldNames_as     : ["acmps_month_yyyy_mm_s"],
                    val_f           : (val) => {return  val},
                    validator_f     : (val) => {return validator_string_fb(val)}},
                cmps_createdTicketsNum_n: {
                    oldNames_as     : ["acmps_createdTicketsNum_n"],
                    val_f           : (val) => {return  val ? val : 0},
                    validator_f     : (val) => {return validator_number_fb(val)}},
                cmps_totalStoreIncomes_byCurrency_c : {
                    oldNames_as     : ["acmps_totalStoreIncomes_byCurrency_c"],
                    val_f           : (val) => {return val ? obj_map_fo(val,(item) => new FB_Cost(item)) : {}},
                    validator_f     : (val) => {return validator_objClass_fb(val, FB_Cost) && validator_objKeys_fb(val, enum_costCurrency_n)}},
                cmps_sendPaymentStatus_e: {
                    oldNames_as     : ["acmps_sendPaymentStatus_e"],
                    val_f           : (val) => {return  val},
                    validator_f     : (val) => {return validator_enum_fb(enum_creatorSendPaymentStatus, val)}},
                cmps_sendPaymentReceiptUrl_s: {
                    oldNames_as     : ["acmps_sendPaymentReceiptUrl_s"],
                    val_f           : (val) => {return  val},
                    validator_f     : (val) => {return validator_null_fb(val) || validator_string_fb(val)}},
                cmps_chargePaymentStatus_e: {
                    oldNames_as     : ["acmps_chargePaymentStatus_e"],
                    val_f           : (val) => {return  val},
                    validator_f     : (val) => {return validator_enum_fb(enum_creatorChargePaymentStatus, val)}},
                cmps_chargePaymentReceiptUrl_s: {
                    oldNames_as     : ["acmps_chargePaymentReceiptUrl_s"],
                    val_f           : (val) => {return  val},
                    validator_f     : (val) => {return validator_null_fb(val) || validator_string_fb(val)}},
                cmps_langCode_e: {
                    oldNames_as     : ["acmps_langCode_e"],
                    val_f           : (val) => {return  val},
                    validator_f     : (val) => {return validator_enum_fb(enum_langCodes, val)}},
                cmps_emailTitle_s: {
                    oldNames_as     : ["acmps_emailTitle_s"],
                    val_f           : (val) => {return  val},
                    validator_f     : (val) => {return validator_string_fb(val)}},
                cmps_emailBodyHtml_s: {
                    oldNames_as     : ["acmps_emailBodyHtml_s"],
                    val_f           : (val) => {return  val},
                    validator_f     : (val) => {return validator_string_fb(val)}},
            },
            FBObj)
    }



}


// =========== 5) ONGOING ==============

// FB_GameStatus
export class FB_GameStatus extends FB_WrapperServerReceived{
    gs_teams_byTeamId
    gs_timeExtensionMinutes_n

    static gs_l_teams_byTeamId = "gs_teams_byTeamId"

    constructor (FBObj) {
        super(FBObj)

        initClass_f(
            'FB_GameStatus',
            this,
            {
                gs_timeExtensionMinutes_n : { oldNames_as :       [],
                    val_f(val )          {return val ? val : 0},
                    validator_f(val)    {return validator_null_fb(val) || validator_typeOf_fb(val, enum_typeof.number)}},
                gs_teams_byTeamId : {
                    oldNames_as :       [],
                    val_f(obj)          {return obj != null ? obj_map_fo(obj, (gs_team_o , teamId_uid) => {
                        return new FB_GameStatus_Team(gs_team_o)
                    }) : {}},
                    validator_f(val)    {return true}},
                gs_creatorStartTime_t: {
                    oldNames_as :       [],
                    val_f(val)          {return val},
                    validator_f(val)    {return validator_null_fb(val) || validator_timestamp_fb(val)}},

            },
            FBObj)
    }

    cm_gs_userIdExist_fb(userId){
        for(let key in this.gs_teams_byTeamId){
            if(this.gs_teams_byTeamId[key].gst_players_byUserId_c[userId]){
                return true
            }

        }
        return false
    }
    cm_gs_getTeamIdByUserId_fuid(userId_uid){


        for(let teamId in this.gs_teams_byTeamId){
            if(this.gs_teams_byTeamId[teamId].gst_players_byUserId_c[userId_uid]){
                return teamId
            }
        }
        return null
    }

}
export class FB_GameStatus_Team {

    gst_netTimeMillScn_byRiddleId_n
    gst_totalPoints_byId_n

    static gst_l_totalPoints_byId_n = "gst_totalPoints_byId_n"
    static gst_l_netTimeMillScn_byRiddleId_n = "gst_netTimeMillScn_byRiddleId_n"
    static gst_l_finishTime_t = "gst_finishTime_t"

    constructor (FBObj ) {


        if(FBObj.gst_players_byUserId_c == null && FBObj.gst_playersJoinTime_byUserId_t != null){
            FBObj.gst_players_byUserId_c = obj_map_fo(FBObj.gst_playersJoinTime_byUserId_t, (playerJoinTeam_t , playerId_uid ) => {
                return {
                    gstp_joinedTime_t : playerJoinTeam_t,
                    gstp_playerId_uid : playerId_uid,
                }
            })
        }

        if(FBObj.gst_totalPoints_n){
            if(!FBObj.gst_totalPoints_byId_n){
                FBObj.gst_totalPoints_byId_n = {}
            }

            FBObj.gst_totalPoints_byId_n['old'] = FBObj.gst_totalPoints_n
        }

        initClass_f(
            'FB_GameStatus_team',
            this,
            {
                gst_teamId_uid:{
                    oldNames_as :       [],
                    val_f(val )          {return val},
                    validator_f(val )    {return validator_string_fb(val)}},
                gst_name_s : {
                    oldNames_as :       ["name"],
                    val_f(val )          {return val},
                    validator_f(val )    {return validator_string_fb(val)}},
                gst_color_s : {
                    oldNames_as :       ["color"],
                    val_f(val )          {return val},
                    validator_f(val )    {return validator_typeOf_fb(val, enum_typeof.string)}},
                gst_teamPassword_s : {
                    oldNames_as :       [],
                    val_f(val )          {return val ? val : "123456"},
                    validator_f(val )    {return validator_typeOf_fb(val, enum_typeof.string)}},
                gst_playerStartTime_t: {
                    oldNames_as :       [],
                    val_f(val )          {return val != null ? val : null},
                    validator_f(val )    {return validator_null_fb(val) || validator_timestamp_fb(val)}},
                gst_missionsArrangementIndex_n: {
                    oldNames_as :       [],
                    val_f(val )          {return val ? val : 0},
                    validator_f(val )    {return validator_number_fb(val)}},
                gst_finishTime_t: {
                    oldNames_as :       [],
                    val_f(val )          {return val},
                    validator_f(val )    {return validator_null_fb(val) || validator_timestamp_fb(val)}},
                gst_totalPoints_byId_n: {
                    oldNames_as :       [],
                    val_f(val )          {return val ? val : {}},
                    validator_f(val )    {return validator_objValNumber_fb(val)}},
                gst_netTimeMillScn_byRiddleId_n: {
                    oldNames_as :       [],
                    val_f(val )          {return val ? val : {}},
                    validator_f(val )    {return validator_obj_fb(val)}},
                gst_players_byUserId_c: {
                    oldNames_as :       [],
                    val_f(players_byUserId_o ) {return players_byUserId_o ? obj_map_fo(players_byUserId_o, (player_o) => {return new FB_GameStatus_team_player(player_o)}) : {}},
                    validator_f(val )          {return validator_objClass_fb(val, FB_GameStatus_team_player)}},
            },
            FBObj)
    }

    gst_m_netTimeMillScn_fn (){
        let ans_n  = 0

        obj_forEach_f(this.gst_netTimeMillScn_byRiddleId_n, (missionNetTime_n) => {
            ans_n+=missionNetTime_n
        })

        return ans_n
    }
    gst_m_totalPoints_n(){
        let ans_n  = 0

        obj_forEach_f(this.gst_totalPoints_byId_n, (totalPoints_n) => {
            ans_n+=totalPoints_n
        })


        return ans_n
    }
}
export class FB_GameStatus_team_player {

    constructor (FBObj ) {
        initClass_f(
            'FB_GameStatus_team',
            this,
            {
                gstp_playerId_uid:{
                    oldNames_as :       [],
                    val_f(val )          {return val},
                    validator_f(val )    {return validator_string_fb(val)}},
                gstp_pathIndex_n: {
                    oldNames_as :       [],
                    val_f(val )          {return val},
                    validator_f(val )    {return validator_number_fb(val) || validator_null_fb(val)}},
                gstp_joinedTime_t: {
                    oldNames_as :       [],
                    val_f(val )          {return val},
                    validator_f(val )    {return validator_timestamp_fb(val)}},

            },
            FBObj)

    }
}





// =========== 6) only client ==============

// Class_FbAuth
export class FB_FbAuth {

    fa_email_s
    fa_userId_uid
    fa_idToken_uid
    fa_refreshToken_uid
    fa_IdTokenExpiresInSec_n
    fa_tokenDate_t
    fa_newUser_b
    fa_name_s
    fa_photoUrl_s
    fa_lastLoginMethods_e

    constructor (FBObj  ) {

        initClass_f(
            'FB_FbAuth',
            this, {
                fa_userId_uid       : {
                    val_f(val) {return val},
                    validator_f(val) {return validator_string_fb(val)}},
                fa_idToken_uid       : {
                    val_f(val) {return val},
                    validator_f(val) {return validator_string_fb(val)}},
                fa_refreshToken_uid       : {
                    val_f(val) {return val},
                    validator_f(val) {return validator_string_fb(val)}},
                fa_IdTokenExpiresInSec_n       : {
                    val_f(val) {return val},
                    validator_f(val) {return validator_number_fb(val)}},
                fa_tokenDate_t       : {
                    val_f(val) {return val},
                    validator_f(val) {return validator_timestamp_fb(val)}},
                fa_newUser_b       : {
                    val_f(val) {return val ? val : false},
                    validator_f(val) {return validator_boolean_fb(val)}},
                fa_name_s       : {
                    val_f(val) {return val},
                    validator_f(val) {return validator_null_fb(val) || validator_string_fb(val)}},
                fa_email_s       : {
                    val_f(val) {return val},
                    validator_f(val) {return validator_null_fb(val) || validator_string_fb(val)}},
                fa_photoUrl_s       : {
                    val_f(val) {return val},
                    validator_f(val) {return validator_null_fb(val) || validator_string_fb(val)}},
                fa_lastLoginMethods_e       : {
                    val_f(val) {return val},
                    validator_f(val) {return validator_null_fb(val) || validator_enum_fb(enum_loginMethods, val)}},
            }, FBObj)

    }

    fa_idTokenExpired_b(){
        // subtract 2 seconds for safety
        return date_nowTime_t() > this.fa_tokenDate_t + ((this.fa_IdTokenExpiresInSec_n-2)*1000)
    }

}

// Cla_AppVersion
export class Cla_AppVersion {
    version ;
    deployDateTime ;

    constructor(obj ) {
        this.version = obj.version
        this.deployDateTime = obj.deployDateTime
    }
}

// FB_Error
export class FB_Error {
    err_time_t
    err_stack_s
    err_userId_uid
    err_name_s
    err_msg_s
    err_viewName_s

    constructor (FBObj ) {

        initClass_f(
            'FB_Error',
            this,
            {
                err_time_t: {
                    oldNames_as     : [],
                    val_f           : (val) => {return val},
                    validator_f     : (val) => {return validator_timestamp_fb(val)}},
                err_msg_s  : {
                    oldNames_as     : [],
                    val_f           : (val) => {return val ? val : ''},
                    validator_f     : (val) => {return validator_string_fb(val)}},
                err_name_s  : {
                    oldNames_as     : [],
                    val_f           : (val) => {return val},
                    validator_f     : (val) => {return validator_string_fb(val)}},
                err_viewName_s  : {
                    oldNames_as     : [],
                    val_f           : (val) => {return val},
                    validator_f     : (val) => {return validator_string_fb(val)}},
                err_viewInfo_s  : {
                    oldNames_as     : [],
                    val_f           : (val) => {return val},
                    validator_f     : (val) => {return validator_string_fb(val)}},
                err_userId_uid  : {
                    oldNames_as     : [],
                    val_f           : (val) => {return val},
                    validator_f     : (val) => {return validator_null_fb(val) || validator_string_fb(val)}},
                err_stack_s  : {
                    oldNames_as     : [],
                    val_f           : (val) => {return val},
                    validator_f     : (val) => {return validator_string_fb(val)}},
                err_runIn_e  : {
                    oldNames_as     : [],
                    val_f           : (val) => {return val ? val : ''},
                    validator_f     : (val) => {return validator_string_fb(val)}},
                err_fullRoute_e  : {
                    oldNames_as     : [],
                    val_f           : (val) => {return val ? val : ''},
                    validator_f     : (val) => {return validator_string_fb(val)}},
                err_ongoingQuestType_e  : {
                    oldNames_as     : [],
                    val_f           : (val) => {return val ? val : ''},
                    validator_f     : (val) => {return validator_string_fb(val) || validator_enum_fb(enum_questTypes, val)}},
                err_ongoingQuestId_uid  : {
                    oldNames_as     : [],
                    val_f           : (val) => {return val ? val : ''},
                    validator_f     : (val) => {return validator_string_fb(val)}},
                err_ongoingEventId_uid  : {
                    oldNames_as     : [],
                    val_f           : (val) => {return val ? val : ''},
                    validator_f     : (val) => {return validator_string_fb(val)}},
            },
            FBObj)
    }

    static err_name_time_t(){
        return 'err_time_t'
    }

    err_m_getId_s(){
        return this.err_time_t + this.err_userId_uid + this.err_name_s
    }
}




// =========== 7) only server ==============

// FB_ticketsManager_xHour
export class FB_TicketsManager {

    constructor (FBObj ) {

        initClass_f(
            'FB_TicketsManager',
            this,
            {
                tm_ticketId_uid: {
                    oldNames_as     : [],
                    val_f           : (val) => {return  val},
                    validator_f     : (val) => {return validator_string_fb(val)}},
                tm_nextAuditTime_t  : {
                    oldNames_as     : [],
                    val_f           : (val) => {return val},
                    validator_f     : (val) => {return validator_timestamp_fb(val)}},
            },
            FBObj)

    }
}

// FB_QuestTicketPayment
export class FB_QuestTicketPayment {

    qtp_ticketId_uid ;
    qtp_authNum_uid ;
    qtp_saleId_uid ;
    qtp_token_uid ;
    qtp_exemptVAT_b ;
    qtp_fullName_s ;
    qtp_cardHolderId_s ;
    qtp_catalogNumber_uid ;
    qtp_description_s ;

    constructor (FBObj ) {
        this.qtp_ticketId_uid       = FBObj.qtp_ticketId_uid
        this.qtp_authNum_uid        = FBObj.qtp_authNum_uid
        this.qtp_saleId_uid         = FBObj.qtp_saleId_uid
        this.qtp_token_uid          = FBObj.qtp_token_uid

        this.qtp_exemptVAT_b        = FBObj.qtp_exemptVAT_b

        this.qtp_fullName_s         = FBObj.qtp_fullName_s
        this.qtp_cardHolderId_s     = FBObj.qtp_cardHolderId_s
        this.qtp_catalogNumber_uid  = FBObj.qtp_catalogNumber_uid
        this.qtp_description_s      = FBObj.qtp_description_s
    }
}

// FB_QuestEventFinishEmail
export class FB_QuestEventFinishEmail {

    constructor (FBObj ) {

        initClass_f(
            'FB_QuestEventFinishEmail',
            this,
            {
                qevfe_sendEmailTime_t: {
                    oldNames_as     : [],
                    val_f           : (val) => {return  val},
                    validator_f     : (val) => {return validator_timestamp_fb(val)}},
                qevfe_questType_e  : {
                    oldNames_as     : [],
                    val_f           : (val) => {return val},
                    validator_f     : (val) => {return validator_enum_fb(enum_questTypes, val)}},
                qevfe_questId_uid  : {
                    oldNames_as     : [],
                    val_f           : (val) => {return val},
                    validator_f     : (val) => {return validator_string_fb(val)}},
                qevfe_eventId_uid  : {
                    oldNames_as     : [],
                    val_f           : (val) => {return val},
                    validator_f     : (val) => {return validator_string_fb(val)}},
                qevfe_teamId_uid  : {
                    oldNames_as     : [],
                    val_f           : (val) => {return val},
                    validator_f     : (val) => {return validator_null_fb(val) || validator_string_fb(val)}},
            },
            FBObj)

    }
}






// =========== Firestore ==============

// FB_QuestExplore
export class FB_QuestExplore {

    qex_questId_uid 
    qex_questType_e 

    qex_name_byLangCode_s ;
    qex_availableTickets_ac 
    qex_langArr_ae 
    qex_shortKeyPrefixId_s 
    qex_creatorId_uid 
    qex_mainLang_e 

    qex_startingLocation_s 
    qex_startingLocationPoint_c 

    qex_metadata_c 
    qex_imgsFiles_blc_ac 

    _qex_durationInMinutes_n 
    _qex_maxPlayersNum_n
    _qex_minPlayersNum_n

    qex_emailBoughtTicket_blc_html
    qex_emailFinishQuest_blc_html
    qex_geoHash4_s 

    static qex_l_startingLocationPoint_c = "qex_startingLocationPoint_c"
    static qex_l_metadata_c = "qex_metadata_c"
    static qex_l_creatorId_uid = "qex_creatorId_uid"

    constructor (FBObj) {


        if(FBObj.qex_langArr_ae == null && FBObj.langArr != null){
            FBObj.qex_langArr_ae = FBObj.langArr
        }

        if(FBObj.qex_imgsFiles_ac == null && FBObj.imgsFiles != null){
            FBObj.qex_imgsFiles_ac = FBObj.imgsFiles
        }

        if(FBObj.qex_imgsFiles_blc_ac == null && FBObj.qex_imgsFiles_ac != null){

            FBObj.qex_imgsFiles_blc_ac = {}
            obj_forEach_f(FBObj.qex_langArr_ae, (langCode_e) => {
                FBObj.qex_imgsFiles_blc_ac[langCode_e] = FBObj.qex_imgsFiles_ac
            })
        }


        initClass_f(
            'FB_QuestExplore',
            this,
            {
                qex_questId_uid : {
                    oldNames_as :       ['questId'],
                    val_f(val)          {return val},
                    validator_f(val)    {return validator_typeOf_fb(val, enum_typeof.string)}},
                qex_shortKeyPrefixId_s : {
                    oldNames_as :       [],
                    val_f(val)          {return val ? val : "00"},
                    validator_f(val)    {return validator_typeOf_fb(val, enum_typeof.string)}},

                qex_questType_e : {
                    oldNames_as :       ['questType'],
                    val_f(val)          {return val},
                    validator_f(val)    {return validator_enum_fb(enum_questTypes, val)}},
                qex_createdDateTime_n : {
                    oldNames_as :       ['createdDateTime'],
                    val_f(val)          {return val ? val : 0},
                    validator_f(val)    {return validator_typeOf_fb(val, enum_typeof.number)}},
                qex_creatorId_uid : {
                    oldNames_as :       ["createdUserId", "qe_creatorId_uid"],
                    val_f(val)          {return val},
                    validator_f(val)    {return validator_typeOf_fb(val, enum_typeof.string)}},

                qex_mainLang_e : {
                    oldNames_as :       ['mainLang'],
                    val_f(val)          {return val},
                    validator_f(val)    {return validator_enum_fb(enum_langCodes, val)}},
                qex_langArr_ae : {
                    oldNames_as :       ['langArr'],
                    val_f(arr)          {return arr ? arr : []},
                    validator_f(arr)    {return validator_enum_array_fb(enum_langCodes, arr)}},

                qex_startingLocation_s : {
                    oldNames_as :       ['startingLocation'],
                    val_f(val)          {return val ? val : ""},
                    validator_f(val)    {return validator_string_fb(val)}},
                qex_startingLocationPoint_c : {
                    oldNames_as :           [],
                    val_f(val)          {return val ? new FB_MapPoint(val) : new FB_MapPoint({})},
                    validator_f(val)    {return validator_null_fb(val) || validator_class_fb(val, FB_MapPoint) }},

                qex_imgsFiles_blc_ac : {
                    oldNames_as :       [],
                    val_f(files_blc_ac)         {return helper_arrToObj_fo(FBObj.qex_langArr_ae, (langCode_e) => {
                        return files_blc_ac[langCode_e] ? Object.values(files_blc_ac[langCode_e]).map((item) => {return new FB_File(item)}) : []})},
                    validator_f(files_blc_ac)   {return validator_onjKeysByEnumVal_fb(files_blc_ac,enum_langCodes)}},
                qex_introVideo_blc_c : {
                    oldNames_as :       [],
                    val_f(files_blc_c)          {return files_blc_c ? obj_map_fo(files_blc_c, (file_o) => {return new FB_File(file_o)}): {}},
                    validator_f(files_blc_c)    {return validator_onjKeysByEnumVal_fb(files_blc_c,enum_langCodes)}},
                qex_name_byLangCode_s : {
                    oldNames_as :       ['name'],
                    val_f(val)          {return val},
                    validator_f(val)    {return validator_objTypeof_fb(val, enum_typeof.string)}},
                qex_description_cla_s : {
                    oldNames_as :       [],
                    val_f(obj)          {return helper_arrToObj_fo(FBObj.qex_langArr_ae, (langCode_e) => {return obj && obj[langCode_e] ? obj[langCode_e] : ""})},
                    validator_f(obj)    {return validator_objTypeof_fb(obj, enum_typeof.string)}},
                qex_whatElse_cla_s : {
                    oldNames_as :       [],
                    val_f(obj)          {return helper_arrToObj_fo(FBObj.qex_langArr_ae, (langCode_e) => {return obj && obj[langCode_e] ? obj[langCode_e] : ""})},
                    validator_f(obj)    {return validator_objTypeof_fb(obj, enum_typeof.string)}},
                qex_whatYouWillGet_cla_s : {
                    oldNames_as :       [],
                    val_f(obj)          {return helper_arrToObj_fo(FBObj.qex_langArr_ae, (langCode_e) => {return obj && obj[langCode_e] ? obj[langCode_e] : ""})},
                    validator_f(obj)    {return validator_objTypeof_fb(obj, enum_typeof.string)}},
                qex_whatToBring_cla_s : {
                    oldNames_as :       [],
                    val_f(obj)          {return helper_arrToObj_fo(FBObj.qex_langArr_ae, (langCode_e) => {return obj && obj[langCode_e] ? obj[langCode_e] : ""})},
                    validator_f(obj)    {return validator_objTypeof_fb(obj, enum_typeof.string)}},
                qex_creatorTerms_cla_s : {
                    oldNames_as :       [],
                    val_f(obj)          {return helper_arrToObj_fo(FBObj.qex_langArr_ae, (langCode_e) => {return obj && obj[langCode_e] ? obj[langCode_e] : ""})},
                    validator_f(obj)    {return validator_objTypeof_fb(obj, enum_typeof.string)}},

                qex_emailBoughtTicket_blc_html : {
                    oldNames_as :       ["qex_emailBoughtTicket_blc_s"],
                    val_f(val)          {return helper_arrToObj_fo(FBObj.qex_langArr_ae, (langCode) => {
                        return (val != null && val[langCode] != null && val[langCode] != "") ? val[langCode] : ass_strings.sentence_defaultBuyEmailText[langCode]})},
                    validator_f(val)    {return validator_objTypeof_fb(val, enum_typeof.string)}},
                qex_emailFinishQuest_blc_html : {
                    oldNames_as :       ["qex_emailFinishQuest_blc_s"],
                    val_f(val)          {return helper_arrToObj_fo(FBObj.qex_langArr_ae, (langCode) => {
                        return (val != null && val[langCode] != null && val[langCode] != "") ? val[langCode] : ass_strings.sentence_defaultFinishedQuest[langCode]})},
                    validator_f(val)    {return validator_objTypeof_fb(val, enum_typeof.string)}},

                qex_introduction_byLangCode_c : {
                    oldNames_as :       ['introduction'],
                    val_f(obj)          {return helper_arrToObj_fo(FBObj.qex_langArr_ae, (langCode_e) => {return obj[langCode_e] ? new FB_Wysiwyg(obj[langCode_e]) : new FB_Wysiwyg({})})},
                    validator_f(obj)    {return validator_objClass_fb(obj, FB_Wysiwyg)}},
                qex_description_byLangCode_c : {
                    oldNames_as :       ['description'],
                    val_f(obj)          {return helper_arrToObj_fo(FBObj.qex_langArr_ae, (langCode_e) => {return obj[langCode_e] ? new FB_Wysiwyg(obj[langCode_e]) : new FB_Wysiwyg({})})},
                    validator_f(obj)    {return validator_objClass_fb(obj, FB_Wysiwyg)}},
                qex_creatorTerms_byLangCode_c : {
                    oldNames_as :       [],
                    val_f(obj)          {return helper_arrToObj_fo(FBObj.qex_langArr_ae, (langCode_e) => {return obj[langCode_e] ? new FB_Wysiwyg(obj[langCode_e]) : new FB_Wysiwyg({})})},
                    validator_f(obj)    {return validator_objClass_fb(obj, FB_Wysiwyg)}},

                _qex_durationInMinutes_n : {
                    oldNames_as :       ['durationInMinutes'],
                    val_f(val)          {return val != null ? val : 0},
                    validator_f(val)    {return validator_typeOf_fb(val, enum_typeof.number)}},
                qex_metadata_c : {
                    oldNames_as :       ['qe_metadata'],
                    val_f(val)          {return val ? new FB_QuestExplore_Metadata(val) : null},
                    validator_f(val)    {return validator_class_fb(val, FB_QuestExplore_Metadata)}},
                qex_utcOffSetHours_n : {
                    oldNames_as :       [],
                    val_f(val)          {return val != null ? val : 2},
                    validator_f(val)    {return validator_typeOf_fb(val, enum_typeof.number)}},

                qex_availableTickets_ac : {
                    oldNames_as :       ['availableCoupons'],
                    val_f(val)          {return val ? Object.values(val).map((item) => {return new FB_QuestExplore_AvailableTickets(item)}) : [] },
                    validator_f(val)    {return validator_arrayClass_fb(val, FB_QuestExplore_AvailableTickets)}},
                qex_availableDates_at  : {
                    oldNames_as :       [],
                    val_f(arr)          {return arr != null ? arr : []},
                    validator_f(arr)    {return validator_array_typeOf_fb(arr, enum_typeof.number)}},
                qex_maxPlayersNum_n : {
                    oldNames_as :       [],
                    val_f(val)          {return val != null ? val : 10},
                    validator_f(val)    {return validator_typeOf_fb(val, enum_typeof.number)}},

                qex_geoHash4_s : {
                    oldNames_as :       [],
                    val_f(val)          {return val},
                    validator_f(val)    {return validator_string_fb(val) || validator_null_fb(val)}},
                qex_whiteLabel_c : {
                    oldNames_as :       [],
                    val_f(val)          {return new FB_WhiteLabel(val || {})},
                    validator_f(val)    {return validator_class_fb(val, FB_WhiteLabel)}},
            },
            FBObj)


        this.qex_maxPlayersNum_n =  FBObj._qex_maxPlayersNum_n
        this.qex_minPlayersNum_n =  FBObj._qex_minPlayersNum_n

    }

    get qex_durationInMinutes_n(){
        return this._qex_durationInMinutes_n
    }
    set qex_durationInMinutes_n(val){

        if(val <= 0 || !validator_number_fb(val)){
            this._qex_durationInMinutes_n = 120
        }else if(val > gv_numbers.maxDurationMinutes){
            this._qex_durationInMinutes_n = gv_numbers.maxDurationMinutes
        }else{
            this._qex_durationInMinutes_n = val
        }
    }
    get qex_maxPlayersNum_n(){
        return this._qex_maxPlayersNum_n
    }
    set qex_maxPlayersNum_n(val ){
        if(val <= 0 || !validator_number_fb(val)){
            this._qex_maxPlayersNum_n = 10
        }else if(val < this._qex_minPlayersNum_n){
            this._qex_maxPlayersNum_n = this._qex_minPlayersNum_n
        }else if(val > 300){
            this._qex_maxPlayersNum_n = 300
        }else{
            this._qex_maxPlayersNum_n = val
        }
    }
    get qex_minPlayersNum_n(){
        return this._qex_minPlayersNum_n
    }
    set qex_minPlayersNum_n(val){

        if(val <= 0 || !validator_number_fb(val)){
            this._qex_minPlayersNum_n = 1
        }else if(val > this._qex_maxPlayersNum_n){
            this._qex_minPlayersNum_n = this._qex_maxPlayersNum_n
        }else{
            this._qex_minPlayersNum_n = val
        }
    }

    cm_qex_getName_fs(system_langCode){

        let langCode = helper_getDisplayLang_e(system_langCode, this.qex_langArr_ae, this.qex_mainLang_e)

        return this.qex_name_byLangCode_s[langCode]
    }

    cm_qex_costRange_s(currentCurrency_e , system_langCode_e){
        let maxCost_n = null
        let minCost_n = null
        let currency_e = null

        obj_forEach_f(this.qex_availableTickets_ac, (availableTicket_c) => {

            let cost_c  = availableTicket_c.qexa_cost_c.c_m_changeCurrency_c(currentCurrency_e)

            let value = cost_c.c_value_n / availableTicket_c.qexa_spots_n

            if(maxCost_n == null && minCost_n == null && currency_e == null){
                maxCost_n = value
                minCost_n = value
                currency_e = cost_c.c_currency_e
            }

            if(maxCost_n > value)
                maxCost_n = value
            if(minCost_n < value)
                minCost_n= value
        })

        return format_costRange_s(maxCost_n, minCost_n, currency_e, this.cm_qex_getDisplayLang_fe(system_langCode_e))
    }
    cm_qex_getDisplayLang_fe(system_langCode_e){

        return helper_getDisplayLang_e(system_langCode_e, this.qex_langArr_ae, this.qex_mainLang_e)
    }

    qex_cm_getNewEventDisplayImg_blc_c(){
        let ans  = {}
        this.qex_langArr_ae.forEach((langCode_e) => {
            ans[langCode_e] = this.qex_imgsFiles_blc_ac[langCode_e][0]
        })

        return ans;
    }
}
export class FB_QuestExplore_AvailableTickets {

    constructor(FBObj){

        if(!FBObj.qexa_description_blc_s && FBObj.qexa_description_s){
            FBObj.qexa_description_blc_s = {iw : FBObj.qexa_description_s}
        }

        initClass_f(
            'FB_QuestExplore_AvailableTickets',
            this,
            {
                qexa_spots_n: {
                    oldNames_as     : ['spots'],
                    val_f       (val) {return val ? val : 10},
                    validator_f (val) {return validator_number_fb(val)}},
                qexa_cost_c: {
                    oldNames_as     : ['cost'],
                    val_f       (val) {return val ? new FB_Cost(val) : new FB_Cost({})},
                    validator_f (val) {return validator_class_fb(val, FB_Cost)}},
                qexa_description_blc_s: {
                    oldNames_as     : [],
                    val_f       (val) {return val ? val : {}},
                    validator_f (val) {return validator_obj_fb(val)}},
                qexa_ticketColor_s: {
                    oldNames_as     : [],
                    val_f       (val) {return val ? val : "#501078"},
                    validator_f (val) {return validator_string_fb(val)}},

            },FBObj)

    }

}
export class FB_QuestExplore_Metadata {

    qexm_availableTicketsType_e 
    static qexm_l_questLocationType_e = "qexm_questLocationType_e"
    static qexm_l_active_b = "qexm_active_b"
    static qexm_l_guide_b = "qexm_guide_b"

    constructor(FBObj){

        initClass_f(
            'FB_QuestExplore_Metadata',
            this,
            {
                qexm_playerChooseEvent_b: {
                    oldNames_as     : ['qexm_withStartingDate_b'],
                    val_f       (val) {return val != null ? val : true},
                    validator_f (val) {return validator_boolean_fb(val)}},
                qexm_defaultApproveTickets_b: {
                    oldNames_as     : [],
                    val_f       (val) {return val != null ? val : false},
                    validator_f (val) {return validator_boolean_fb(val)}},
                qexm_active_b: {
                    oldNames_as     : [],
                    val_f       (val) {return val != null ? val : false},
                    validator_f (val) {return validator_boolean_fb(val)}},
                qexm_displayStartingLocation_b: {
                    oldNames_as     : [],
                    val_f       (val) {return val != null ? val : true},
                    validator_f (val) {return validator_boolean_fb(val)}},
                qexm_availableTicketsType_e: {
                    oldNames_as     : [],
                    val_f       (val) {return val != null ? val : enum_availableTicketsTypes_s.specificTicket},
                    validator_f (val) {return validator_enum_fb(enum_availableTicketsTypes_s, val)}},
                qexm_tqProfitPercentage_n :{ // 1->100
                    val_f       (val) {return val != null ? val : 15},
                    validator_f (val) {return validator_number_fb(val)}},
                qeam_closedQuest_b:{
                    val_f       (val) {return val != null ? val : false},
                    validator_f (val) {return validator_boolean_fb(val)}},
                qexm_oneEventEachMonth_b:{
                    val_f       (val) {return val != null ? val : false},
                    validator_f (val) {return validator_boolean_fb(val)}},
                qexm_questLocationType_e:{
                    oldNames_as     : ['qexm_questType_e'],
                    val_f       (val) {return val != null ? val : enum_questLocationsTypes_s.virtual},
                    validator_f (val) {return validator_enum_fb(enum_questLocationsTypes_s, val)}},
                qexm_guide_b:{
                    val_f       (val) {return val != null ? val : true},
                    validator_f (val) {return validator_boolean_fb(val)}},
                qexm_startClockType_e : {
                    oldNames_as       : [],
                    val_f(val)          {return val != null && validator_enum_fb(enum_questEventStartClockTypes_s, val) ? val : enum_questEventStartClockTypes_s.creatorStartClock},
                    validator_f(val)    {return validator_enum_fb(enum_questEventStartClockTypes_s, val)}},
            },FBObj)
    }
}
export class FB_QuestExplore_Info {
    constructor (FBObj) {

        initClass_f('FB_QuestExplore_Info', this, {

            qexi_questId_uid : {
                val_f(val) {return val},
                validator_f(val) {return validator_typeOf_fb(val, enum_typeof.string)}},
            qexi_questType_e: {
                val_f(val) {return val},
                validator_f(val) {return validator_enum_fb(enum_questTypes, val)}},

            qexi_shareNum_facebook_n: {
                val_f(val) {return val ? val : 0},
                validator_f(val) {return validator_typeOf_fb(val, enum_typeof.number)}},
            qexi_shareNum_whatsapp_n: {
                val_f(val) {return val ? val : 0},
                validator_f(val) {return validator_typeOf_fb(val, enum_typeof.number)}},
            qexi_shareNum_gmail_n: {
                val_f(val) {return val ? val : 0},
                validator_f(val) {return validator_typeOf_fb(val, enum_typeof.number)}},
            qexi_shareNum_email_n: {
                val_f(val) {return val ? val : 0},
                validator_f(val) {return validator_typeOf_fb(val, enum_typeof.number)}},
            qexi_shareNum_twitter_n: {
                val_f(val) {return val ? val : 0},
                validator_f(val) {return validator_typeOf_fb(val, enum_typeof.number)}},

            qexi_difficultyAvg_n: {
                oldNames_as     : ['qexi_difficultySum_n'],
                val_f           (val) {return val ? val : 0},
                validator_f     (val) {return validator_typeOf_fb(val, enum_typeof.number)}},
            qexi_overallRatingAvg_n: {
                oldNames_as     : ['qexi_overallRatingSum_n'],
                val_f(val) {return val ? val : 0},
                validator_f(val) {return validator_typeOf_fb(val, enum_typeof.number)}},

            qexi_reviewedNum_n: {
                val_f(val) {return val ? val : 0},
                validator_f(val) {return validator_typeOf_fb(val, enum_typeof.number)}},
            qexi_participated_n: {
                val_f(val) {return val ? val : 0},
                validator_f(val) {return validator_typeOf_fb(val, enum_typeof.number)}},
        }, FBObj)
    }
}
export class FB_QuestExplore_GeoHash {

    qg_langArr_ae
    qg_mainLang_e
    qg_questName_blc_s

    static qg_l_geoHash_s = "qg_geoHash_s"

    constructor(FBObj){
        initClass_f(
            'FB_QuestExplore_GeoHash',
            this,
            {
                qg_questId_uid: {
                    oldNames_as     : [],
                    val_f           : (val) => {return val},
                    validator_f     : (val) => {return validator_string_fb(val)}
                },
                qg_geoHash_s: {
                    oldNames_as     : [],
                    val_f           : (val) => {return val},
                    validator_f     : (val) => {return validator_string_fb(val)}
                },
                qg_startingLocation_c: {
                    oldNames_as     : [],
                    val_f           : (val) => {return new FB_MapPoint(val)},
                    validator_f     : (val) => {return validator_class_fb(val, FB_MapPoint)}
                },
                qg_questName_blc_s: {
                    oldNames_as     : [],
                    val_f           : (val) => {return val ? val :{}},
                    validator_f     : (val) => {return validator_onjKeysByEnumVal_fb(val, enum_langCodes) && validator_objValStr_fb(val)}
                },
                qg_langArr_ae : {
                    oldNames_as     : [],
                    val_f           : (val) => {return val},
                    validator_f     : (val) => {return validator_enum_array_fb(enum_langCodes, val)}
                },
                qg_mainLang_e: {
                    oldNames_as     : [],
                    val_f           : (val) => {return val},
                    validator_f     : (val) => {return validator_enum_fb(enum_langCodes, val)}
                },
                qg_overallRating_n: {
                    oldNames_as     : [],
                    val_f           : (val) => {return val ? val : null},
                    validator_f     : (val) => {return validator_number_fb(val) || validator_null_fb(val)}
                },
            }, FBObj)
    }

    qg_m_questName_s (systemLangCode_e){
        return this.qg_questName_blc_s[helper_getDisplayLang_e(systemLangCode_e, this.qg_langArr_ae, this.qg_mainLang_e)]
    }
}

// FB_QuestBody_Metadata
export class FB_QuestBody_Metadata{

    qmb_missions_showAllLocks_b 
    qbm_audio_missionErrorUrl_s 
    qbm_quest_hiddenCodesMode_e 

    constructor(FBObj ){


        if(FBObj.qbm_missions_cluesMode_e == null && FBObj.qbm_missions_supportClues_b){
            FBObj.qbm_missions_cluesMode_e = enum_cluesMode_e.counter
        }

        if(FBObj.qbm_quest_missionsArrangements_b && FBObj.qbm_quest_missionsArrangements_e == null){
            FBObj.qbm_quest_missionsArrangements_e = enum_arrangeMissionsType_s.random
        }

        if(FBObj.qbm_quest_supportClueCodes_b && FBObj.qbm_quest_hiddenCodesMode_e == null){
            FBObj.qbm_quest_hiddenCodesMode_e = enum_hiddenCodesTypes.e_clueCounter_n
        }


        initClass_f(
            'FB_QuestBody_Metadata',
            this,
            {
                qbm_quest_supportListMissions_b : {
                    oldNames_as       : ['qbm_supportFeature_missionsRiddles_b','supportFeature_sideMissions_b'],
                    val_f(val)          {return val ? val : false},
                    validator_f(val)    {return validator_boolean_fb(val)}},
                qbm_quest_supportCardsMissions_b : {
                    oldNames_as       : [],
                    val_f(val)          {return val ? val : false},
                    validator_f(val)    {return validator_boolean_fb(val)}},
                qbm_quest_supportMapMissions_b : {
                    oldNames_as       : ['qbm_supportFeature_mapRiddles_b'],
                    val_f(val)          {return val ? val : false},
                    validator_f(val)    {return validator_boolean_fb(val)}},
                qbm_quest_supportMapLastMissions_b : {
                    oldNames_as       : ['qbm_supportFeature_lastRiddles_b', 'supportFeature_lastRiddles_b'],
                    val_f(val)          {return val ? val : false},
                    validator_f(val)    {return validator_boolean_fb(val)}},
                qbm_quest_supportListLastMissions_b: {
                    oldNames_as       : [],
                    val_f(val)          {return val ? val : false},
                    validator_f(val)    {return validator_boolean_fb(val)}},
                qbm_quest_hiddenCodesMode_e : {
                    oldNames_as       : ['qbm_quest_supportClueCodes_e', 'qbm_quest_supportClueCodes_b', 'qbm_supportFeature_clueCodes_b', 'supportFeature_clueCodes_b'],
                    val_f(val)          {return val ? val : enum_hiddenCodesTypes.e_none_n},
                    validator_f(val)    {return validator_enum_fb(enum_hiddenCodesTypes, val)}},
                qbm_quest_supportChat_b : {
                    oldNames_as       : ['qbm_supportFeature_chat_b', 'supportFeature_chat_b'],
                    val_f(val)          {return val ? val : false},
                    validator_f(val)    {return validator_boolean_fb(val)}},
                qbm_quest_supportChatTranslate_b : {
                    oldNames_as       : [],
                    val_f(val)          {return val ? val : false},
                    validator_f(val)    {return validator_boolean_fb(val)}},
                qbm_quest_startClockType_e: {
                    oldNames_as       : [],
                    val_f(val)          {return validator_enum_fb(enum_questEventStartClockTypes_s, val) ? val : enum_questEventStartClockTypes_s.creatorStartClock},
                    validator_f(val)    {return validator_enum_fb(enum_questEventStartClockTypes_s, val)}},
                qbm_quest_missionsArrangements_e:{
                    oldNames_as       : [],
                    val_f(val)          {return val!=null ? val : enum_arrangeMissionsType_s.none},
                    validator_f(val)    {return validator_enum_fb(enum_arrangeMissionsType_s, val)}},
                qbm_quest_finishQuest_e:{
                    oldNames_as       : [],
                    val_f(val)          {return val!=null ? val : enum_finishQuest_s.listMissions_all},
                    validator_f(val)    {return validator_enum_fb(enum_finishQuest_s, val)}},
                qbm_quest_hideTeamsStatus_b : {
                    oldNames_as       : [],
                    val_f(val)          {return val ? val : false},
                    validator_f(val)    {return validator_boolean_fb(val)}},
                qbm_quest_questMode_e: {
                    oldNames_as       : ['qbm_quest_teamsType_ew'],
                    val_f(val)          {return val!=null ? val : enum_questMode_s.teams},
                    validator_f(val)    {return validator_enum_fb(enum_questMode_s, val)}},

                qbm_missions_supportMapSection_b : {
                    oldNames_as       : ['qbm_supportFeature_mapSection_b', 'supportFeature_mapSection_b'],
                    val_f(val)          {return val ? val : false},
                    validator_f(val)    {return validator_boolean_fb(val)}},
                qbm_missions_supportFinishSection_b : {
                    oldNames_as       : ['qbm_supportFeature_finishSection_b', 'supportFeature_finishSection_b'],
                    val_f(val)          {return val ? val : false},
                    validator_f(val)    {return validator_boolean_fb(val)}},
                qbm_missions_supportMissionsPoints_b : {
                    oldNames_as       : ['qbm_supportFeature_missionsPoints_b', 'qbm_supportFeature_missionsPointes_b'],
                    val_f(val)          {return val != null ? val : true},
                    validator_f(val)    {return validator_boolean_fb(val)}},

                qmb_missions_showAllLocks_b : {
                    oldNames_as       : [],
                    val_f(val)          {return val!=null ? val : true},
                    validator_f(val)    {return validator_boolean_fb(val)}},

                qbm_missions_supportClues_b: {
                    oldNames_as       : ['qbm_support_clues_b'],
                    val_f(val)          {return val != null ? val : false},
                    validator_f(val)    {return validator_boolean_fb(val)}},
                qbm_missions_cluesMode_e: {
                    oldNames_as       : [],
                    val_f(val)          {return val != null ? val : enum_cluesMode_e.none},
                    validator_f(val)    {return validator_enum_fb(enum_cluesMode_e, val)}},

                qbm_missions_supportSkips_b: {
                    oldNames_as       : ['qbm_support_skips_b'],
                    val_f(val)          {return val != null ? val : false},
                    validator_f(val)    {return validator_boolean_fb(val)}},
                qbm_missions_supportStartLockClock_b: {
                    oldNames_as       : [],
                    val_f(val)          {return val != null ? val : false},
                    validator_f(val)    {return validator_boolean_fb(val)}},

                qbm_missions_locksType_e: {
                    val_f(val)          {return val != null ? val : enum_missions_LocksType_s.regular},
                    validator_f(val)    {return validator_enum_fb(enum_missions_LocksType_s, val)}},

                qbm_cardMissions_lastMissions_b : {
                    oldNames_as       : ["qbm_quest_supportCardsLastMissions_b"],
                    val_f(val)          {return val ? val : false},
                    validator_f(val)    {return validator_boolean_fb(val)}},

                qbm_listMissions_supportMissionsGroups_b : {
                    oldNames_as       : ['qbm_supportFeature_missionsGroups_b'],
                    val_f(val)          {return val ? val : false},
                    validator_f(val)    {return validator_boolean_fb(val)}},
                qbm_listMissions_supportMissionsGroupsLevels_b : {
                    oldNames_as       : ['qbm_supportFeature_missionsGroupsLevels_b'],
                    val_f(val)          {return val ? val : false},
                    validator_f(val)    {return validator_boolean_fb(val)}},

                qbm_mapMissions_supportDisplayRiddlesNum_b : {
                    oldNames_as       : ['qbm_supportFeature_displayRiddlesNum_b', 'supportFeature_displayRiddlesNum_b'],
                    val_f(val)          {return val ? val : false},
                    validator_f(val)    {return validator_boolean_fb(val)}},
                qbm_mapMissions_missionsType_e : {
                    oldNames_as       : ['qbm_mapMissions_mapType_e', 'qbm_openMapType_e', 'openMapType_e'],
                    val_f(val)          {return val ? val : enum_mapMissionsTypes.markers},
                    validator_f(val)    {return validator_enum_fb(enum_mapMissionsTypes, val)}},
                qbm_mapMissions_mapType2_e : {
                    oldNames_as       : [],
                    val_f(val)          {return val ? val : enum_mapTypes.osm},
                    validator_f(val)    {return validator_enum_fb(enum_mapTypes, val)}},
                qbm_mapMissions_showGpsBtn_b : {
                    oldNames_as       : [],
                    val_f(val)          {return val != null ? val : true},
                    validator_f(val)    {return validator_boolean_fb(val)}},
                qbm_mapMissions_showZoomControl_b : {
                    oldNames_as       : [],
                    val_f(val)          {return val != null ? val : true},
                    validator_f(val)    {return validator_boolean_fb(val)}},
                qbm_mapMissions_rightZoomBtns_b : {
                    oldNames_as       : [],
                    val_f(val)          {return val != null ? val : false},
                    validator_f(val)    {return validator_boolean_fb(val)}},

                qbm_audio_chatUrl_s:{
                    oldNames_as       : [],
                    val_f(val)          {return val ? val : enum_audioUrl.notify_s},
                    validator_f(val)    {return validator_string_fb(val)},
                },
                qbm_audio_missionErrorUrl_s:{
                    oldNames_as       : [],
                    val_f(val)          {return val ? val : enum_audioUrl.error_s},
                    validator_f(val)    {return validator_string_fb(val)},
                },
                qbm_audio_mapMissionsUrl_s:{
                    oldNames_as       : [],
                    val_f(val)          {return val ? val : enum_audioUrl.claps_s},
                    validator_f(val)    {return validator_string_fb(val)},
                },
                qbm_audio_listMissionsUrl_s:{
                    oldNames_as       : [],
                    val_f(val)          {return val ? val : enum_audioUrl.claps_s},
                    validator_f(val)    {return validator_string_fb(val)},
                },
                qbm_audio_cardsMissionsUrl_s:{
                    oldNames_as       : [],
                    val_f(val)          {return val ? val : enum_audioUrl.claps_s},
                    validator_f(val)    {return validator_string_fb(val)},
                },
                qbm_audio_lastMissionsUrl_s:{
                    oldNames_as       : [],
                    val_f(val)          {return val ? val : enum_audioUrl.lastRiddle_s},
                    validator_f(val)    {return validator_string_fb(val)},
                },




            },
            FBObj)

    }
}

// FB_QuestBody
export class FB_QuestBody {

    qb_metadata_c;
    qb_missionsArrangements_ac;
    qb_cardsMissions_ac;
    qb_mapMissions_ac;
    qb_langArr_ae;
    qb_listMissions_ac;
    qb_missionsGroup_ac;
    qb_theme_c;
    qb_mapData_c;

    constructor(FBObj) {


        if (FBObj.qb_cluesCodes_as && !FBObj.qb_cluesCodes_ac) {
            FBObj.qb_cluesCodes_ac = FBObj.qb_cluesCodes_as.map((clueCode_s) => new FB_QuestBody_ClueCode({qbcc_code_s: clueCode_s}))
        }

        initClass_f(
            'FB_QuestBody',
            this,
            {
                qb_questId_uid: {
                    oldNames_as: ["questId"],
                    val_f(val) {
                        return val
                    },
                    validator_f(val) {
                        return validator_string_fb(val)
                    }
                },
                qb_questType_e: {
                    oldNames_as: ["questType"],
                    val_f(val) {
                        return val
                    },
                    validator_f(val) {
                        return validator_enum_fb(enum_questTypes, val)
                    }
                },

                qb_mapMissions_ac: {
                    oldNames_as: ["qb_riddles_ac", "riddles"],
                    val_f(arr) {
                        return arr ? Object.values(arr).map((item) => {
                            return new FB_QuestBody_Riddle(item, FBObj.qb_langArr_ae, FBObj.qb_metadata_c)
                        }) : []
                    },
                    validator_f(val) {
                        return validator_arrayClass_fb(val, FB_QuestBody_Riddle)
                    }
                },
                qb_mapLastMissions_ac: {
                    oldNames_as: ["qb_lastRiddles_ac", "lastRiddles"],
                    val_f(arr) {
                        return arr ? Object.values(arr).map((item) => {
                            return new FB_QuestBody_Riddle(item, FBObj.qb_langArr_ae, FBObj.qb_metadata_c)
                        }) : []
                    },
                    validator_f(val) {
                        return validator_arrayClass_fb(val, FB_QuestBody_Riddle)
                    }
                },
                qb_cardsMissions_ac: {
                    oldNames_as: [],
                    val_f(arr) {
                        return arr ? Object.values(arr).map((item) => {
                            return new FB_QuestBody_Riddle(item, FBObj.qb_langArr_ae, FBObj.qb_metadata_c)
                        }) : []
                    },
                    validator_f(val) {
                        return validator_arrayClass_fb(val, FB_QuestBody_Riddle)
                    }
                },
                qb_listMissions_ac: {
                    oldNames_as: ["qb_missionsRiddles_ac", "sideMissions"],
                    val_f(arr) {
                        return arr ? Object.values(arr).map((item) => {
                            return new FB_QuestBody_Riddle(item, FBObj.qb_langArr_ae, FBObj.qb_metadata_c)
                        }) : []
                    },
                    validator_f(val) {
                        return validator_arrayClass_fb(val, FB_QuestBody_Riddle)
                    }
                },
                qb_listLastMissions_ac: {
                    oldNames_as: [],
                    val_f(arr) {
                        return arr ? Object.values(arr).map((item) => {
                            return new FB_QuestBody_Riddle(item, FBObj.qb_langArr_ae, FBObj.qb_metadata_c)
                        }) : []
                    },
                    validator_f(val) {
                        return validator_arrayClass_fb(val, FB_QuestBody_Riddle)
                    }
                },

                qb_missionsArrangements_ac: {
                    oldNames_as: [],
                    val_f(val_ac) {
                        return val_ac ? Object.values(val_ac).map(val_an => new FB_QuestBody_MissionsArrangement(val_an)) : []
                    },
                    validator_f(val) {
                        return true
                    }
                },
                qb_missionsGroup_ac: {
                    oldNames_as: [],
                    val_f(arr) {
                        return arr ? Object.values(arr).map(item => {
                            return new FB_QuestBody_MissionsGroup(item, FBObj.qb_langArr_ae)
                        }) : []
                    },
                    validator_f(arr) {
                        return validator_arrayClass_fb(arr, FB_QuestBody_MissionsGroup)
                    }
                },
                qb_mapMissionsGroup_ac: {
                    oldNames_as: [],
                    val_f(arr) {
                        return arr ? Object.values(arr).map(item => {
                            return new FB_QuestBody_MissionsGroup(item, FBObj.qb_langArr_ae)
                        }) : []
                    },
                    validator_f(arr) {
                        return validator_arrayClass_fb(arr, FB_QuestBody_MissionsGroup)
                    }
                },

                qb_startingCluesNum_n: {
                    oldNames_as: ["startingCluesNum"],
                    val_f(val) {
                        return val != null ? val : 1
                    },
                    validator_f(val) {
                        return validator_number_fb(val)
                    }
                },
                qb_startingSkipsNum_n: {
                    oldNames_as: ["startingSkipsNum"],
                    val_f(val) {
                        return val != null ? val : 1
                    },
                    validator_f(val) {
                        return validator_number_fb(val)
                    }
                },

                qb_mainLang_e: {
                    oldNames_as: ["qb_defaultLang_e", "mainLang"],
                    val_f(val) {
                        return val
                    },
                    validator_f(val) {
                        return validator_enum_fb(enum_langCodes, val)
                    }
                },
                qb_langArr_ae: {
                    oldNames_as: ["qb_supportedLangCodes_ae", "qb_support_ae", "langArr"],
                    val_f(val) {
                        return Object.values(val)
                    },
                    validator_f(arr) {
                        return validator_enum_array_fb(enum_langCodes, arr)
                    }
                },

                qb_cluesCodes_ac: {
                    oldNames_as: [],
                    val_f(val) {
                        return val ? val.map((item) => new FB_QuestBody_ClueCode(item)) : []
                    },
                    validator_f(val) {
                        return validator_arrayClass_fb(val, FB_QuestBody_ClueCode)
                    }
                },
                qb_metadata_c: {
                    oldNames_as: ["metadataQB"],
                    val_f(val) {
                        return new FB_QuestBody_Metadata(val)
                    },
                    validator_f(val) {
                        return true
                    }
                },
                qb_theme_c: {
                    oldNames_as: [],
                    val_f(val) {
                        return new FB_QuestBody_Theme(val)
                    },
                    validator_f(val) {
                        return true
                    }
                },

                qb_mapData_c: {
                    oldNames_as: ["mapData"],
                    val_f(val) {
                        return new FB_MapData(val)
                    },
                    validator_f(val) {
                        return true
                    }
                },
                qb_questRules_byLangCode_c: {
                    oldNames_as: [],
                    val_f(obj) {
                        return obj_map_fo(obj, (item) => {
                            return new FB_Wysiwyg(item)
                        })
                    },
                    validator_f(obj) {
                        return validator_objClass_fb(obj, FB_Wysiwyg) && validator_onjKeysByEnumVal_fb(obj, enum_langCodes)
                    }
                },

                qb_cardsLastMissions_ac: {
                    oldNames_as: [],
                    val_f(arr) {
                        return arr ? Object.values(arr).map((item) => {
                            return new FB_QuestBody_Riddle(item, FBObj.qb_langArr_ae, FBObj.qb_metadata_c)
                        }) : []
                    },
                    validator_f(val) {
                        return true
                    }
                },
            },
            FBObj)

        if (this.qb_metadata_c.qbm_listMissions_supportMissionsGroups_b) {
            this.cm_qb_arrangeMissionsGroup_f(this.qb_listMissions_ac, this.qb_missionsGroup_ac)
        }

        if ([enum_mapMissionsTypes.polygons_area, enum_mapMissionsTypes.squares_linear_groups].includes(this.qb_metadata_c.qbm_mapMissions_missionsType_e)) {
            this.cm_qb_arrangeMissionsGroup_f(this.qb_mapMissions_ac, this.qb_mapMissionsGroup_ac)
        }

    }

    cm_qb_arrangeMissionsGroup_f(qb_missions_ac, qb_missionsGroup_ac) {

        let listMissionsRiddlesIds_an = qb_missions_ac.map(qb_riddle_c => {
            return qb_riddle_c.qbr_riddleId_n
        })
        let riddleIdsInGroup_an = []

        // remove from missions groups
        qb_missionsGroup_ac.forEach(qb_missionGroup_c => {

            qb_missionGroup_c.qbmg_riddlesIds_an = qb_missionGroup_c.qbmg_riddlesIds_an.filter(qbmg_riddleId_n => {
                return listMissionsRiddlesIds_an.includes(qbmg_riddleId_n)
            })
            riddleIdsInGroup_an.push(...qb_missionGroup_c.qbmg_riddlesIds_an)
        })


        // add to missions group
        let newMissionsGroup_c = new FB_QuestBody_MissionsGroup({
            qbmg_missionsGroupId_n: search_getArrObjFreeIndex(qb_missionsGroup_ac, "qbmg_missionsGroupId_n")
        }, this.qb_langArr_ae)

        listMissionsRiddlesIds_an.forEach(riddleId_n => {

            if (!riddleIdsInGroup_an.includes(riddleId_n)) {
                newMissionsGroup_c.qbmg_riddlesIds_an.push(riddleId_n)
            }
        })
        if (newMissionsGroup_c.qbmg_riddlesIds_an.length > 0) {
            qb_missionsGroup_ac.push(newMissionsGroup_c)
        }

    }

    cm_qb_getDisplayLangCode_e(system_langCode) {

        if (this.qb_langArr_ae.includes(system_langCode)) {
            return system_langCode
        } else {
            return this.qb_mainLang_e
        }
    }

    cm_qb_addMapRiddle_f(position_c, rectangleSize_c) {

        let newRiddleId_n = search_getArrObjFreeIndex(this.qb_mapMissions_ac, enum_fbPath.qbr_riddleId_n)
        this.qb_mapMissions_ac.push(new FB_QuestBody_Riddle({
            qbr_metadata_c: new FB_QuestBody_Riddle_metadata({}),
            qbr_riddleId_n: newRiddleId_n,
            qbr_riddlePosition_c: position_c,
            qbr_rectangleSize_c: rectangleSize_c,
        }, this.qb_langArr_ae, this.qb_metadata_c))

        if ([enum_mapMissionsTypes.squares_linear_groups, enum_mapMissionsTypes.squares_linear_groups_hide].includes(this.qb_metadata_c.qbm_mapMissions_missionsType_e)) {

            if (this.qb_mapMissionsGroup_ac.length === 0) {
                this.qb_mapMissionsGroup_ac = [new FB_QuestBody_MissionsGroup({
                    qbmg_missionsGroupId_n: 0
                })]
            }

            this.qb_mapMissionsGroup_ac[0].qbmg_riddlesIds_an.push(newRiddleId_n)
        }

        return newRiddleId_n
    }

    cm_qb_addSideMission_f(qb_missionGroup_ac, qb_missions_ac, missionsGroupId_n) {

        let riddleId_n = search_getArrObjFreeIndex(qb_missions_ac, enum_fbPath.qbr_riddleId_n)

        qb_missions_ac.push(new FB_QuestBody_Riddle({
            qbr_metadata_c: new FB_QuestBody_Riddle_metadata({}),
            qbr_riddleId_n: riddleId_n,
        }, this.qb_langArr_ae, this.qb_metadata_c))


        // add to missionsGroup
        if (missionsGroupId_n != null) {
            let missionsGroupIndex = helper_getObjIndexInArray_fn(qb_missionGroup_ac, enum_fbPath.qbmg_missionsGroupId_n, missionsGroupId_n)

            if (!qb_missionGroup_ac[missionsGroupIndex].qbmg_riddlesIds_an.includes(riddleId_n)) {
                qb_missionGroup_ac[missionsGroupIndex].qbmg_riddlesIds_an.push(riddleId_n)
            }
            // todo: remove this / handle duplicate old code
            let removeDuplicate = []
            qb_missionGroup_ac[missionsGroupIndex].qbmg_riddlesIds_an.forEach((riddleId_n) => {
                if (!removeDuplicate.includes(riddleId_n))
                    removeDuplicate.push(riddleId_n)
            })
            qb_missionGroup_ac[missionsGroupIndex].qbmg_riddlesIds_an = removeDuplicate
        }
    }

    cm_qb_addMissionGroup_f(qb_missionsGroup_ac) {

        qb_missionsGroup_ac.push(new FB_QuestBody_MissionsGroup({
            qbmg_missionsGroupId_n: search_getArrObjFreeIndex(qb_missionsGroup_ac, "qbmg_missionsGroupId_n")
        }, this.qb_langArr_ae))
    }

    cm_qb_getMissionsArrangement_an(qb_missionsArrangementsIndex_n, missionCollection_e) {

        if (this.qb_metadata_c.qbm_quest_missionsArrangements_e !== enum_arrangeMissionsType_s.none
            && this.qb_missionsArrangements_ac[qb_missionsArrangementsIndex_n] != null) {
            return this.qb_missionsArrangements_ac[qb_missionsArrangementsIndex_n].qbma_missionsIndexes_byMissionCollection_an[missionCollection_e]
        }

        switch (missionCollection_e) {
            case enum_subCollection_teamStatus.CARDS_MISSIONS:
                return this.qb_cardsMissions_ac.map((riddle_c, index_n) => {
                    return index_n
                })
            case enum_subCollection_teamStatus.MAP_MISSIONS:
                break;
        }
    }
}
export class FB_QuestBody_Theme {
    constructor(FBObj) {

        if (FBObj == null) {
            FBObj = {}
        }

        initClass_f(
            'FB_QuestBody_Theme',
            this,
            {
                qbt_backgroundImg_s: {
                    oldNames_as: [],
                    val_f: (val) => {
                        return val ? val : ''
                    },
                    validator_f: (val) => {
                        return validator_string_fb(val)
                    }
                },
            },
            FBObj)
    }
}
export class FB_QuestBody_MissionsGroup {
    constructor(FBObj) {

        let langArr_ae = Object.values(enum_langCodes)

        initClass_f(
            'FB_QuestBody_MissionsGroup',
            this,
            {
                qbmg_name_byLangCode_s: {
                    oldNames_as: [],
                    val_f: (obj) => {
                        return helper_arrToObj_fo(langArr_ae, langCode_e => {
                            return obj && obj[langCode_e] ? obj[langCode_e] : ass_strings.twoWords_newGroup[langCode_e]
                        })
                    },
                    validator_f(val) {
                        return true
                    }
                },
                qbmg_riddlesIds_an: {
                    oldNames_as: [],
                    val_f(val) {
                        return val ? Object.values(val) : []
                    },
                    validator_f(arr) {
                        return validator_array_typeOf_fb(arr, enum_typeof.number)
                    }
                },
                qbmg_imgFile_c: {
                    oldNames_as: [],
                    val_f(val) {
                        return val ? new FB_File(val) : new FB_File({})
                    },
                    validator_f(val) {
                        return validator_class_fb(val, FB_File)
                    }
                },
                qbmg_missionsGroupId_n: {
                    oldNames_as: [],
                    val_f(val) {
                        return val
                    },
                    validator_f(val) {
                        return validator_number_fb(val)
                    }
                },
                qbmg_pointsToUnlock_n: {
                    oldNames_as: [],
                    val_f(val) {
                        return val != null ? val : 0
                    },
                    validator_f(val) {
                        return validator_number_fb(val)
                    }
                },
            },
            FBObj)
    }
}
export class FB_QuestBody_MissionsArrangement {
    constructor(FBObj) {

        initClass_f(
            'FB_QuestBody_MissionsGroup',
            this,
            {
                qbma_name_s: {
                    oldNames_as: [],
                    val_f: val => val ? val : "",
                    validator_f: val => validator_string_fb(val)
                },
                qbma_groupsIndexes_byMissionCollection_an: {
                    oldNames_as: [],
                    val_f: (val_by_an) => {
                        return val_by_an ? obj_map_fo(val_by_an, (val_an) => {
                            return Object.values(val_an)
                        }) : []
                    },
                    validator_f: (val_by_an) => {
                        return true
                    },
                },
                qbma_missionsIndexes_byMissionCollection_an: {
                    oldNames_as: [],
                    val_f: (val_by_an) => {
                        return val_by_an ? obj_map_fo(val_by_an, (val_an) => {
                            return Object.values(val_an)
                        }) : []
                    },
                    validator_f: (val_by_an) => {
                        return true
                    },
                }
            },
            FBObj)
    }
}
export class FB_QuestBody_ClueCode {
    constructor(FBObj) {

        initClass_f(
            'FB_QuestBody_ClueCode',
            this,
            {
                qbcc_code_s: {
                    val_f: (val) => {
                        return val
                    },
                    validator_f: (val) => {
                        return validator_string_fb(val)
                    }
                },
                qbcc_points_n: {
                    val_f: (val) => {
                        return val ? val : 0
                    },
                    validator_f: (val) => {
                        return validator_number_fb(val)
                    }
                },
            },
            FBObj)
    }
}

// FB_QuestBody_Riddle
export class FB_QuestBody_Riddle {

    qbr_metadata_c
    qbr_locks_ac

    constructor(FBObj, langArr_ae, qb_metadata_c) {

        if (FBObj.qbr_mapData_c == null && FBObj.qbr_metadata_c && FBObj.qbr_metadata_c.mapData != null) {
            FBObj.qbr_mapData_c = FBObj.qbr_metadata_c.mapData

        }
        obj_forEach_f(FBObj.qbr_riddleData_byLangCode_c, (riddleData) => {
            if (riddleData.qbrd_imgFile_c == null && FBObj.squareImg_c != null) {
                riddleData.qbrd_imgFile_c = FBObj.squareImg_c
            }
        })

        // refactor: move blc to bottom tree
        if (FBObj.qbr_riddleData_byLangCode_c != null) {

            for (let langCode in FBObj.qbr_riddleData_byLangCode_c) {
                // qbr_title_blc_s
                if (FBObj.qbr_title_blc_s == null) {
                    FBObj.qbr_title_blc_s = {}
                }
                FBObj.qbr_title_blc_s[langCode] = FBObj.qbr_riddleData_byLangCode_c[langCode].qbrd_title_s

                // qbr_subtitle_blc_s
                if (FBObj.qbr_subtitle_blc_s == null) {
                    FBObj.qbr_subtitle_blc_s = {}
                }
                FBObj.qbr_subtitle_blc_s[langCode] = FBObj.qbr_riddleData_byLangCode_c[langCode].qbrd_subtitle_s

                if (FBObj.qbr_body_blc_c == null) {
                    FBObj.qbr_body_blc_c = {}
                }
                FBObj.qbr_body_blc_c[langCode] = FBObj.qbr_riddleData_byLangCode_c[langCode].qbrd_body_c

                // qbr_locks_ac
                if (FBObj.qbr_locks_ac == null) {
                    FBObj.qbr_locks_ac = []
                }
                ;
                FBObj.qbr_riddleData_byLangCode_c[langCode].qbrd_locks_ac.forEach((qbrd_lock_c, lockIndex_n) => {

                    if (FBObj.qbr_locks_ac[lockIndex_n] == null) {

                        let qbrl_questions_ac = []
                        if (qbrd_lock_c.qbrdl_questions_ac) {
                            qbrd_lock_c.qbrdl_questions_ac.forEach(qbrdl_question_c => {
                                qbrl_questions_ac.push({
                                    qbrlq_type_e: qbrdl_question_c.qbrdlq_type_e,
                                    qbrlq_ans_blc_ac: {[langCode]: qbrdl_question_c.qbrdlq_ans_as},
                                    qbrlq_ansNum_blc_n: {[langCode]: qbrdl_question_c.qbrdlq_ansNum_n},
                                    qbrlq_ansOptions_blc_ac: {[langCode]: qbrdl_question_c.qbrdlq_ansOptions_as},
                                    qbrlq_body_blc_c: {[langCode]: qbrdl_question_c.qbrdlq_body_c},
                                    qbrlq_caseSensitive_b: qbrdl_question_c.qbrdlq_caseSensitive_b,
                                })
                            })
                        }
                        FBObj.qbr_locks_ac.push({
                            qbrl_type_e: qbrd_lock_c.type,
                            qbrl_body_blc_c: {[langCode]: qbrd_lock_c.body},
                            qbrl_title_blc_s: {[langCode]: qbrd_lock_c.title},
                            qbrl_qrCode_s: qbrd_lock_c.qbrdl_code_s,
                            qbrl_questions_ac: qbrl_questions_ac
                        })

                    } else {
                        FBObj.qbr_locks_ac[lockIndex_n].qbrl_body_blc_c[langCode] = qbrd_lock_c.body
                        FBObj.qbr_locks_ac[lockIndex_n].qbrl_title_blc_s[langCode] = qbrd_lock_c.title
                        FBObj.qbr_locks_ac[lockIndex_n].qbrl_qrCode_s = qbrd_lock_c.qbrdl_code_s

                        qbrd_lock_c.qbrdl_questions_ac.forEach((qbrdl_question_c, questionIndex_n) => {

                            if (FBObj.qbr_locks_ac[lockIndex_n].qbrl_questions_ac[questionIndex_n] == null) {

                                FBObj.qbr_locks_ac[lockIndex_n].qbrl_questions_ac[questionIndex_n] = {
                                    qbrlq_type_e: qbrdl_question_c.qbrdlq_type_e,
                                    qbrlq_ans_blc_ac: {[langCode]: qbrdl_question_c.qbrdlq_ans_as},
                                    qbrlq_ansNum_blc_n: {[langCode]: qbrdl_question_c.qbrdlq_ansNum_n},
                                    qbrlq_ansOptions_blc_ac: {[langCode]: qbrdl_question_c.qbrdlq_ansOptions_as},
                                    qbrlq_body_blc_c: {[langCode]: qbrdl_question_c.qbrdlq_body_c},
                                    qbrlq_caseSensitive_b: qbrdl_question_c.qbrdlq_caseSensitive_b,
                                }
                            } else {
                                FBObj.qbr_locks_ac[lockIndex_n].qbrl_questions_ac[questionIndex_n].qbrlq_ans_blc_ac[langCode] = qbrdl_question_c.qbrdlq_ans_as
                                FBObj.qbr_locks_ac[lockIndex_n].qbrl_questions_ac[questionIndex_n].qbrlq_ansNum_blc_n[langCode] = qbrdl_question_c.qbrdlq_ansNum_n
                                FBObj.qbr_locks_ac[lockIndex_n].qbrl_questions_ac[questionIndex_n].qbrlq_ansOptions_blc_ac[langCode] = qbrdl_question_c.qbrdlq_ansOptions_as
                                FBObj.qbr_locks_ac[lockIndex_n].qbrl_questions_ac[questionIndex_n].qbrlq_body_blc_c[langCode] = qbrdl_question_c.qbrdlq_body_c
                            }


                        })

                    }
                })

                // qbr_clues_ac
                if (FBObj.qbr_clues_ac == null) {
                    FBObj.qbr_clues_ac = []
                }
                FBObj.qbr_riddleData_byLangCode_c[langCode].qbrd_clues_ac.forEach((qbrd_clue_c, index) => {
                    if (FBObj.qbr_clues_ac[index] == null) {
                        FBObj.qbr_clues_ac.splice(index, 0, {
                            qbrc_title_blc_s: {langCode: qbrd_clue_c.title},
                            qbrc_body_blc_c: {langCode: qbrd_clue_c.body}
                        })
                    } else {
                        FBObj.qbr_clues_ac[index].qbrc_title_blc_s[langCode] = qbrd_clue_c.title
                        FBObj.qbr_clues_ac[index].qbrc_body_blc_c[langCode] = qbrd_clue_c.body
                    }
                })

                // qbr_imgFile_blc_c
                if (FBObj.qbr_imgFile_blc_c == null) {
                    FBObj.qbr_imgFile_blc_c = {}
                }
                FBObj.qbr_imgFile_blc_c[langCode] = FBObj.qbr_riddleData_byLangCode_c[langCode].qbrd_imgFile_c

                // qbr_finishSection_blc_c
                if (FBObj.qbr_finishSection_blc_c == null) {
                    FBObj.qbr_finishSection_blc_c = {}
                }
                FBObj.qbr_finishSection_blc_c[langCode] = FBObj.qbr_riddleData_byLangCode_c[langCode].qbrd_finishSection_c
            }

            FBObj.qbr_riddleData_byLangCode_c = null
        }

        langArr_ae = Object.values(langArr_ae)

        if (FBObj.qbr_points_n != null && FBObj.qbr_locks_ac[0] && !(FBObj.qbr_locks_ac[0].qbrl_points_n >= 0)) {

            let length_n = FBObj.qbr_locks_ac.length
            FBObj.qbr_locks_ac.forEach((lock_c, index_n) => {
                lock_c.qbrl_points_n =
                    index_n === 0
                        ? Math.ceil(FBObj.qbr_points_n / length_n)
                        : Math.floor(FBObj.qbr_points_n / length_n)
            })

            FBObj.qbr_points_n = null
        }

        initClass_f(
            'FB_QuestBody_Riddle',
            this,
            {
                qbr_riddleId_n: {
                    oldNames_as: ["storageId", "missionId_n"],
                    val_f(val) {
                        return val
                    },
                    validator_f(val) {
                        return validator_number_fb(val)
                    }
                },

                qbr_title_blc_s: {
                    oldNames_as: [],
                    val_f: (obj) => {
                        return helper_arrToObj_fo(langArr_ae, langCode_e => {
                            return obj && obj[langCode_e] ? obj[langCode_e] : ass_strings.twoWords_newMission[langCode_e]
                        })
                    },
                    validator_f(obj) {
                        return validator_objTypeof_fb(obj, enum_typeof.string)
                    }
                },
                qbr_subtitle_blc_s: {
                    oldNames_as: [],
                    val_f: (obj) => {
                        return helper_arrToObj_fo(langArr_ae, langCode_e => {
                            return obj && obj[langCode_e] ? obj[langCode_e] : ""
                        })
                    },
                    validator_f(obj) {
                        return validator_null_fb(obj) || validator_objTypeof_fb(obj, enum_typeof.string)
                    }
                },
                qbr_body_blc_c: {
                    oldNames_as: [],
                    val_f: (obj) => {
                        return helper_arrToObj_fo(langArr_ae, langCode_e => {
                            return obj && obj[langCode_e] ? new FB_Wysiwyg(obj[langCode_e]) : new FB_Wysiwyg({})
                        })
                    },
                    validator_f(obj) {
                        return validator_objClass_fb(obj, FB_Wysiwyg)
                    }
                },
                qbr_imgFile_blc_c: {
                    oldNames_as: [],
                    val_f(obj) {
                        return helper_arrToObj_fo(langArr_ae, langCode_e => {
                            return obj && obj[langCode_e] ? new FB_File(obj[langCode_e]) : new FB_File({})
                        })
                    },
                    validator_f(obj) {
                        return validator_objClass_fb(obj, FB_File)
                    }
                },
                qbr_finishSection_blc_c: {
                    oldNames_as: [],
                    val_f(obj) {
                        return helper_arrToObj_fo(langArr_ae, langCode_e => {
                            return obj && obj[langCode_e] ? new FB_Wysiwyg(obj[langCode_e]) : new FB_Wysiwyg({})
                        })
                    },
                    validator_f(obj) {
                        return validator_objClass_fb(obj, FB_Wysiwyg)
                    }
                },
                qbr_locks_ac: {
                    oldNames_as: [],
                    val_f(arr) {
                        return arr ? Object.values(arr).map((item) => {
                            return new FB_QuestBody_Riddle_Lock(item, langArr_ae)
                        }) : []
                    },
                    validator_f(arr) {
                        return validator_arrayClass_fb(arr, FB_QuestBody_Riddle_Lock)
                    }
                },
                qbr_clues_ac: {
                    oldNames_as: [],
                    val_f: (arr) => {
                        return arr ? Object.values(arr).map((item) => {
                            return new FB_QuestBody_Riddle_Clue(item, langArr_ae)
                        }) : []
                    },
                    validator_f: (arr) => {
                        return validator_arrayClass_fb(arr, FB_QuestBody_Riddle_Clue)
                    },
                    // attExists_b         : (arr) => {return qb_metadata_c ? qb_metadata_c.qbm_missions_supportClues_b: true}
                },

                qbr_riddlePosition_c: {
                    oldNames_as: ["position_c"],
                    val_f(val) {
                        return val ? new FB_MapPoint(val) : new FB_MapPoint({})
                    },
                    validator_f(val) {
                        return validator_class_fb(val, FB_MapPoint)
                    }
                },
                qbr_rectangleSize_c: {
                    oldNames_as: [],
                    val_f(val) {
                        return val ? new FB_MapPoint(val) : new FB_MapPoint({
                            mp_lat_n: gv_numbers.defaultRectangleSize_lat,
                            mp_lng_n: gv_numbers.defaultRectangleSize_lng
                        })
                    },
                    validator_f(val) {
                        return validator_class_fb(val, FB_MapPoint)
                    }
                },
                qbr_pathToNextMission_ac: {
                    oldNames_as: [],
                    val_f(val) {
                        return val == null ? [] : Object.values(val).map(item => {
                            return new FB_MapPoint(item)
                        })
                    },
                    validator_f(val) {
                        return validator_arrayClass_fb(val, FB_MapPoint)
                    }
                },

                qbr_metadata_c: {
                    oldNames_as: ["metadata"],
                    val_f(val) {
                        return val ? new FB_QuestBody_Riddle_metadata(val) : new FB_QuestBody_Riddle_metadata({})
                    },
                    validator_f(val) {
                        return validator_class_fb(val, FB_QuestBody_Riddle_metadata)
                    }
                },
                qbr_mapData_c: {
                    oldNames_as: [],
                    val_f(val) {
                        return val ? new FB_MapData(val) : new FB_MapData({})
                    },
                    validator_f(val) {
                        return validator_class_fb(val, FB_MapData)
                    }
                },
                qbr_theme_c: {
                    oldNames_as: [],
                    val_f(val) {
                        return val ? new FB_QuestBody_Riddle_theme(val) : new FB_QuestBody_Riddle_theme({})
                    },
                    validator_f(val) {
                        return validator_class_fb(val, FB_QuestBody_Riddle_theme)
                    }
                },
            },
            FBObj)
    }

    cm_qbr_addNewClue_f(title_blc_s, langArr_ae) {
        this.qbr_clues_ac.push(
            new FB_QuestBody_Riddle_Clue({
                qbrc_title_blc_s: title_blc_s,
                qbrc_body_blc_c: new FB_EncryptValue({_enc_value_s: '<div></div>'})
            }, langArr_ae))
    }

    cm_qbr_addNewLock_f(title_blc_s, langArr_ae) {
        this.qbr_locks_ac.push(
            new FB_QuestBody_Riddle_Lock({
                qbrl_type_e: enum_lockTypes.WORDS,
                qbrl_title_blc_s: title_blc_s,
                qbrl_body_blc_c: null,
                qbrl_qrCode_s: null,
                qbrl_questions_ac: [new FB_QuestBody_Riddle_Lock_Question({})],
                qbrl_skippable_b: null,
            }, langArr_ae))
    }

    cm_gbr_totalPoints_n() {
        let ans_n = 0
        this.qbr_locks_ac.forEach(qbr_lock_c => {
            ans_n += qbr_lock_c.qbrl_points_n
        })
        return ans_n
    }

}
export class FB_QuestBody_Riddle_theme {
    constructor(FBObj) {

        initClass_f(
            'FB_QuestBody_Riddle_theme',
            this,
            {
                qbrt_font_s: {
                    val_f(val) {
                        return val ? val : 'SecularOne Regular'
                    },
                    validator_f(val) {
                        return validator_null_fb(val) || validator_typeOf_fb(val, enum_typeof.string)
                    }
                },
                qbrt_backgroundColor_s: {
                    val_f(val) {
                        return val ? val : '#000000'
                    },
                    validator_f(val) {
                        return validator_typeOf_fb(val, enum_typeof.string)
                    }
                },
                qbrt_textColor_s: {
                    val_f(val) {
                        return val ? val : '#ffffff'
                    },
                    validator_f(val) {
                        return validator_null_fb(val) || validator_typeOf_fb(val, enum_typeof.string)
                    }
                },
                qbrt_textSize_s: {
                    val_f(val) {
                        return val ? val : '24px'
                    },
                    validator_f(val) {
                        return validator_null_fb(val) || validator_typeOf_fb(val, enum_typeof.string)
                    }
                },
            },
            FBObj)

    }
}
export class FB_QuestBody_Riddle_Lock {

    qbrl_videoMaxTime_n
    qbrl_gpsLocation_c

    constructor(FBObj, langArr_ae) {

        initClass_f(
            'FB_QuestBody_Riddle_Lock',
            this,
            {
                qbrl_type_e: {
                    oldNames_as: [],
                    val_f(val_e) {return val_e ? val_e : enum_lockTypes.WORDS},
                    validator_f(val_e) {return validator_enum_fb(enum_lockTypes, val_e)}
                },
                qbrl_body_blc_c: {
                    oldNames_as: [],
                    val_f: (obj) => {
                        return helper_arrToObj_fo(langArr_ae, langCode_e => {
                            return obj && obj[langCode_e] ? new FB_Wysiwyg(obj[langCode_e]) : new FB_Wysiwyg({})
                        })
                    },
                    validator_f: (obj) => {return validator_objClass_fb(obj, FB_Wysiwyg)}
                },
                qbrl_title_blc_s: {
                    oldNames_as: [],
                    val_f(obj) {
                        return helper_arrToObj_fo(langArr_ae, (langCode_e) => {
                            return obj && obj[langCode_e] ? obj[langCode_e] : ""
                        })
                    },
                    validator_f(obj) {
                        return validator_objTypeof_fb(obj, enum_typeof.string)
                    }
                },
                qbrl_qrCode_s: {
                    oldNames_as: [],
                    val_f: (val) => {
                        return val ? val : ''
                    },
                    validator_f: (val) => {
                        return validator_typeOf_fb(val, enum_typeof.string)
                    },
                    attExists_b: () => {
                        return FBObj.qbrl_type_e === enum_lockTypes.QR_CODE
                    }
                },

                qbrl_questions_ac: {
                    oldNames_as: [],
                    val_f(arr) {
                        return arr ? Object.values(arr).map(item => {
                            return new FB_QuestBody_Riddle_Lock_Question(item)
                        }) : []
                    },
                    validator_f(arr) {
                        return validator_arrayClass_fb(arr, FB_QuestBody_Riddle_Lock_Question)
                    }
                },
                qbrl_skippable_b: {
                    oldNames_as: [],
                    val_f: (val) => {
                        return val != null ? val : false
                    },
                    validator_f: (val) => {
                        return validator_typeOf_fb(val, enum_typeof.boolean)
                    },
                },
                qbrl_autoApprove_b: {
                    oldNames_as: [],
                    val_f: (val) => {
                        return val != null ? val : false
                    },
                    validator_f: (val) => {
                        return validator_typeOf_fb(val, enum_typeof.boolean)
                    },
                },
                qbrl_guideGiveScore_b: {
                    oldNames_as: [],
                    val_f: (val) => {
                        return val != null ? val : false
                    },
                    validator_f: (val) => {
                        return validator_typeOf_fb(val, enum_typeof.boolean)
                    },
                },
                qbrl_points_n: {
                    val_f: val => val >= 0 ? val : 100,
                    validator_f: val =>  validator_number_fb(val),
                },
                qbrl_minPoints_n: {
                    val_f: val => val ? val : 30,
                    validator_f: val =>  validator_number_fb(val),
                },
                qbrl_errorPointsCost_n: {
                    val_f: val => val ? val : 10,
                    validator_f: val =>  validator_number_fb(val),
                },
                qbrl_totalTimeInSeconds_n: {
                    oldNames_as: [],
                    val_f: (val) => {
                        return val != null ? val : 60
                    },
                    validator_f: (val) => {
                        return validator_number_fb(val)
                    },
                },
                qbrl_videoMaxTime_n: {
                    oldNames_as: [],
                    val_f: (val) => {return val ? val : enum_missions_Locks_video_time.sec20},
                    validator_f: (val) => {return validator_number_fb(val)},
                },
                qbrl_gpsLocation_c: {
                    oldNames_as: [],
                    val_f: val => new FB_MapPoint(val ? val: {}),
                    validator_f: val => validator_class_fb(val, FB_MapPoint),
                }
            }, FBObj)

    }

    gbrl_f_locationInRadius_b(userGeoLocation_c){
        const distanceMaters = helper_distanceTwoPointsMeters_fn({
            lat1 : userGeoLocation_c.ugl_latitude_n,
            lon1 : userGeoLocation_c.ugl_longitude_n,
            lat2 : this.qbrl_gpsLocation_c.mp_lat_n,
            lon2 : this.qbrl_gpsLocation_c.mp_lng_n,
        })

        return this.qbrl_gpsLocation_c.mp_radiusMaters_n - distanceMaters > 0
    }

}
export class FB_QuestBody_Riddle_Lock_Question {


    constructor(FBObj) {


        initClass_f(
            'FB_QuestBody_Riddle_Data_Lock_Question',
            this,
            {
                qbrlq_type_e: {
                    oldNames_as: [],
                    val_f(val) {
                        return val ? val : enum_lockQuestionsTypes.WORDS
                    },
                    validator_f(val) {
                        return validator_enum_fb(enum_lockQuestionsTypes, val)
                    }
                },
                qbrlq_ans_blc_ac: {
                    oldNames_as: ['qbrlq_ans_blc_as'],
                    val_f: (obj) => {
                        return obj_mapValues_fo(enum_langCodes, (langCode_e) => {
                            return obj && obj[langCode_e] ? Object.values(obj[langCode_e]).map(val_c => new FB_EncryptValue(val_c)) : []
                        })
                    },
                    validator_f(obj) {
                        return validator_onjKeysByEnumVal_fb(obj, enum_langCodes)
                    }
                },
                qbrlq_ansNum_blc_n: {
                    oldNames_as: [],
                    val_f: (obj) => {
                        return obj_mapValues_fo(enum_langCodes, (langCode_e) => {
                            return obj && obj[langCode_e] ? obj[langCode_e] : 0
                        })
                    },
                    validator_f(obj) {
                        return validator_onjKeysByEnumVal_fb(obj, enum_langCodes) && validator_objTypeof_fb(obj, enum_typeof.number)
                    }
                },
                qbrlq_ansOptions_blc_ac: {
                    oldNames_as: ['qbrlq_ansOptions_blc_as'],
                    val_f: (obj) => {
                        return obj_mapValues_fo(enum_langCodes, (langCode_e) => {
                            return obj && obj[langCode_e] ? obj_toArray_fo(obj[langCode_e]).map((val_c => new FB_EncryptValue(val_c))) : []
                        })
                    },
                    validator_f(obj) {
                        return validator_onjKeysByEnumVal_fb(obj, enum_langCodes)
                    }
                },
                qbrlq_body_blc_c: {
                    oldNames_as: [],
                    val_f: (obj) => {
                        return obj_mapValues_fo(enum_langCodes, langCode_e => {
                            return obj && obj[langCode_e] ? new FB_Wysiwyg(obj[langCode_e]) : new FB_Wysiwyg({})
                        })
                    },
                    validator_f(obj) {
                        return validator_onjKeysByEnumVal_fb(obj, enum_langCodes) && validator_objClass_fb(obj, FB_Wysiwyg)
                    }
                },
                qbrlq_caseSensitive_b: {
                    oldNames_as: [],
                    val_f(val) {
                        return val ? val : false
                    },
                    validator_f(val) {
                        return validator_typeOf_fb(val, enum_typeof.boolean)
                    }
                },
            },
            FBObj)

    }

}
export class FB_QuestBody_Riddle_Clue {
    constructor(FBObj, langArr_ae) {

        initClass_f(
            'FB_QuestBody_Riddle_Clue',
            this,
            {
                qbrc_title_blc_s: {
                    oldNames_as: [],
                    val_f: (obj) => {
                        return obj
                    },
                    validator_f: (obj) => {
                        return validator_objTypeof_fb(obj, enum_typeof.string)
                    }
                },
                qbrc_body_blc_c: {
                    oldNames_as: [],
                    val_f: (obj) => {
                        return helper_arrToObj_fo(langArr_ae, langCode_e => {

                            // todo: remove this (handle old version using wysiwyg class)
                            if (obj && obj[langCode_e] && obj[langCode_e].w_body_s) {
                                obj[langCode_e]._enc_value_s = obj[langCode_e].w_body_s
                            }

                            return obj && obj[langCode_e] ? new FB_EncryptValue(obj[langCode_e]) : new FB_EncryptValue({_enc_value_s: '<div></div>'})
                        })
                    },
                    validator_f: (obj) => {
                        return validator_null_fb(obj) || validator_objClass_fb(obj, FB_EncryptValue)
                    }
                },
                qbrc_pointsWorth_n: {
                    oldNames_as: [],
                    val_f: (val) => {
                        return val != null ? val : 0
                    },
                    validator_f: (val) => {
                        return validator_number_fb(val)
                    }
                },
            }, FBObj)


    }
}
export class FB_QuestBody_Riddle_metadata {
    constructor(FBObj) {

        initClass_f(
            'FB_QuestBody_Riddle_metadata',
            this,
            {
                qbrm_finishSection_b: {
                    oldNames_as: [],
                    val_f: val => val != null ? val : false,
                    validator_f: val => validator_typeOf_fb(val, enum_typeof.boolean)},
                qbrm_mapSection_b: {
                    oldNames_as: [],
                    val_f: val => val != null ? val : false,
                    validator_f: val => validator_typeOf_fb(val, enum_typeof.boolean)},
                qbrm_displayLocksInOrder_b: {
                    oldNames_as: [],
                    val_f: val => val != null ? val : false,
                    validator_f: val => validator_typeOf_fb(val, enum_typeof.boolean)},
            }, FBObj)
    }
}



// ============= local functions =============================

// initClass_f
export const initClass_f = (className_s, currentClassPointer_o, initClassObj_byAttName, newData_byAttName) => {

    //initClassObj_byAttName[attName].oldNames_as
    //initClassObj_byAttName[attName].val_f
    //initClassObj_byAttName[attName].validator_f

    for(let attName in initClassObj_byAttName){

        // old names
        if(initClassObj_byAttName[attName].oldNames_as != null){

            obj_forEach_f(initClassObj_byAttName[attName].oldNames_as, (oldName ) => {
                if( newData_byAttName[attName] == null
                    && newData_byAttName[oldName] != null){
                    newData_byAttName[attName] = newData_byAttName[oldName]
                }
            })
        }

        // set value
        currentClassPointer_o[attName] = initClassObj_byAttName[attName].val_f(newData_byAttName[attName])

        // check validator
        if( !initClassObj_byAttName[attName].validator_f(currentClassPointer_o[attName])){
            console.log('(initClass_f)', attName, currentClassPointer_o[attName])
            throw `${className_s} /  ${attName}`
        }
    }
}